import { ArrowUpward } from "@mui/icons-material";
import AddBoxIcon from "@mui/icons-material/AddBox";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import IndeterminateCheckBoxOutlinedIcon from "@mui/icons-material/IndeterminateCheckBoxOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LaunchIcon from "@mui/icons-material/Launch";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import PersonIcon from "@mui/icons-material/Person";
import Person2Icon from "@mui/icons-material/Person2";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import RefreshIcon from "@mui/icons-material/Refresh";
import SendIcon from "@mui/icons-material/Send";
import SettingsIcon from "@mui/icons-material/Settings";
import SummarizeIcon from "@mui/icons-material/Summarize";
import ThumbDownOffAltRoundedIcon from "@mui/icons-material/ThumbDownOffAltRounded";
import ThumbUpOffAltRoundedIcon from "@mui/icons-material/ThumbUpOffAltRounded";
import UpdateIcon from "@mui/icons-material/Update";
import ViewAgendaIcon from "@mui/icons-material/ViewAgenda";
import {
  Box,
  Button,
  Divider,
  IconButton,
  LinearProgress,
  MenuItem,
  SwipeableDrawer,
  TablePagination,
  Slider,
} from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Autocomplete from "@mui/material/Autocomplete";
import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import Backdrop from "@mui/material/Backdrop";
import Chip from "@mui/material/Chip";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { alpha, styled } from "@mui/material/styles";
import KPeeLogo from "../LogoKPee1.png";
import {
  DataGrid,
  GridActionsCellItem,
  GridRowParams,
  GridToolbar,
} from "@mui/x-data-grid";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { decode } from "base-64";
import dayjs from "dayjs";
import { useFormik } from "formik";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from 'sonner';
import * as Yup from "yup";
import { api } from "../api";
import AuthContext from "../auth/AuthProvider";
import { fetchName, fetchToken } from "../auth/Token";
import Header from "../components/Header";
import LoanAdviseCommodity from "../components/LoanAdviseCommodity";
import { FormatedDate } from "../components/SavingsDetails";
import { useMode } from "../theme";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const MessageBox_com = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  margin: "4px",
  maxWidth: "310px",
  display: "flex",
  borderRadius: "20px",
  marginLeft: "auto",
  display: "flex",
  flexDirection: "column",
}));

const MessageBox_goi = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  margin: "4px",
  maxWidth: "310px",
  display: "flex",
  borderRadius: "20px",
  display: "flex",
  flexDirection: "column",
}));

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

const MessageArea = ({
  nego_id,
  setChat_area,
  fetch_chats,
  username,
  userimage,
  user_phone,
  agreed_price,
  agree,
  nego_status,
  order_id,
}) => {
  const [data, setData] = useState([]);
  const [final_price, setFinal_price] = useState(agreed_price);
  const [agreee, setAgreee] = useState(agree);
  const [message, setMessage] = useState("");
  const [order_details, setOrder_details] = useState([]);
  const [openn, setOpenn] = useState(false);

  const fetch_all_orders = () => {
    api
      .get(`/account/get/one/orders/${order_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setOrder_details(response.data?.all_orders);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const pic = (pic) => {
    const de = decode(pic);
    return `data:image/jpeg;base64,${btoa(de)}`;
  };

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  const handleCloses = () => {
    setOpenn(false);
  };
  const handleOpen = () => {
    setOpenn(true);
  };

  const negoStatusSet = (status) => {
    handleOpen();
    const data = new FormData();
    data.append("nego_id", nego_id);
    data.append("status", status);

    api
      .post("/account/end/negotiation", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response.data);
        fetch_messages();
        fetch_chats();
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        handleCloses();
      });
  };

  useEffect(() => {
    const data = new FormData();
    data.append("nego_id", nego_id);
    data.append("agree_price", final_price);
    api
      .post("/account/set/agree/on/price", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        fetch_messages();
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [final_price]);

  const fetch_messages = () => {
    api
      .get(`/account/open/messages/${nego_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setData(response.data);
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        fetch_chats();
      });
  };
  const make_agree = () => {
    setAgreee((prevState) => !prevState);
    const data = new FormData();
    data.append("nego_id", nego_id);
    data.append("agree", agreee);
    api
      .post("/account/agree/on/price", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        fetch_messages();
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const sendMessage = (event) => {
    event.preventDefault();
    const data = new FormData();
    data.append("nego_id", nego_id);
    data.append("message", message);

    api
      .post("/account/send/message", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        fetch_messages();
        setMessage("");
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    fetch_messages();
    fetch_all_orders();
  }, [nego_id]);

  useEffect(() => {
    fetch_messages();
    // const intervalId = setInterval(fetch_messages, 2000);
    // return () => clearInterval(intervalId);
  }, [nego_id]);

  return data.nego ? (
    <>
      <Box sx={{ marginRight: "auto" }}>
        <IconButton onClick={() => setChat_area()} color="error">
          <CancelIcon />
        </IconButton>
      </Box>
      <Box
        sx={{
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "#f1faee",
          borderTopLeftRadius: "7px",
          borderTopRightRadius: "7px",
          paddingTop: 2,
          paddingBottom: 2,
        }}
      >
        <Avatar
          alt={username}
          src={pic(userimage)}
          sx={{ width: 65, height: 65 }}
        />
        <Typography variant="body2">
          <b>{username}</b>
        </Typography>
        <Typography variant="body2">
          <b>{user_phone}</b>
        </Typography>
      </Box>
      <Box
        sx={{
          mt: 1,
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography
          textAlign="center"
          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
        >
          <b>Agreed Price: {currencyFormat.format(final_price)} </b>
          <TextField
            value={final_price}
            onChange={(e) => setFinal_price(e.target.value)}
            label="Final Price"
            type="number"
            size="small"
            disabled={nego_status !== "Ongoing" ? true : false}
            sx={{ ml: 1, borderRadius: 7 }}
          />
          <IconButton
            disabled={nego_status !== "Ongoing" ? true : false}
            color={agreee === true ? "primary" : "success"}
            onClick={make_agree}
          >
            <CheckCircleIcon />
          </IconButton>

          {order_details[0] ? (
            <DetailsModal item={order_details[0]} />
          ) : (
            <CircularProgress size={20} />
          )}
          <Button
            id="demo-customized-button"
            aria-controls={open ? "demo-customized-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            variant="contained"
            disableElevation
            disabled={nego_status !== "Ongoing" ? true : false}
            sx={{ borderRadius: 5 }}
            color="warning"
            onClick={handleClick}
            endIcon={<KeyboardArrowDownIcon />}
          >
            End negotiation
          </Button>
          <StyledMenu
            id="demo-customized-menu"
            MenuListProps={{
              "aria-labelledby": "demo-customized-button",
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
          >
            <MenuItem onClick={() => negoStatusSet("Success")} disableRipple>
              <ThumbUpOffAltRoundedIcon />
              Success
            </MenuItem>
            <MenuItem
              onClick={() => negoStatusSet("Unsuccessful")}
              disableRipple
            >
              <ThumbDownOffAltRoundedIcon />
              Unsuccessful
            </MenuItem>
          </StyledMenu>
        </Typography>
      </Box>
      <Box
        sx={{
          mt: 2,
          mb: 1,
          maxHeight: "40vh",
          overflow: "auto",
          backgroundColor: "#ccdbdc",
          "&::-webkit-scrollbar": {
            width: "7px",
          },
          "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#888",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "#555",
          },
        }}
      >
        {data?.chats &&
          data?.chats
            .slice()
            .reverse()
            .map((item) =>
              item.username === fetchName() ? (
                <MessageBox_com>
                  <div style={{ marginBottom: "3px" }}>
                    <Typography variant="subtitle">
                      <b style={{ marginRight: "5px" }}>You</b>
                      <FormatedDate value={item.datetime} />
                    </Typography>
                  </div>
                  <div>
                    <Typography>
                      <span>{item.message}</span>
                    </Typography>
                  </div>
                </MessageBox_com>
              ) : (
                <MessageBox_goi>
                  <div style={{ marginBottom: "3px" }}>
                    <Typography variant="subtitle">
                      <b style={{ marginRight: "5px" }}>{item.username}</b>
                      <FormatedDate value={item.datetime} />
                    </Typography>
                  </div>
                  <div>
                    <Typography>
                      <span>{item.message}</span>
                    </Typography>
                  </div>
                </MessageBox_goi>
              )
            )}
      </Box>
      <Box sx={{ display: "flex", flexDirection: "row" }}>
        {nego_status !== "Ongoing" ? (
          <Typography
            variant="subtitle"
            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
            sx={{ margin: "auto" }}
          >
            Order Closed
          </Typography>
        ) : (
          <form onSubmit={sendMessage}>
            <TextField
              required
              size="small"
              sx={{ borderRadius: 20, mt: 2, minWidth: 530 }}
              placeholder="Type a message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
            <IconButton
              sx={{ marginTop: 2 }}
              size="small"
              onClick={sendMessage}
              color="secondary"
            >
              <SendIcon />
            </IconButton>
          </form>
        )}
      </Box>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openn}
        onClick={handleCloses}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  ) : (
    <Box sx={{ width: "100%" }}>
      <LinearProgress variant="indeterminate" />
    </Box>
  );
};

const ChatUI = ({ order_id, setUi }) => {
  const [open, setOpen] = React.useState(true);
  const [chats, setChats] = useState([]);
  const [details, setDetails] = useState();
  const [header_details, setHeader_Details] = useState();
  const [uimage, setUimage] = useState();
  const [message, setMessage] = useState("");
  const [final_price, setFinal_price] = useState(
    details?.aggreed_price ? details?.aggreed_price : null
  );
  const [agree, setAgree] = useState(details?.agree);
  const [personaInfo, setPersonaInfo] = useState([]);

  useEffect(() => {
    const data = new FormData();
    data.append("nego_id", details?.nego_id);
    data.append("agree_price", final_price);
    api
      .post("/account/set/agree/on/price", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        negotiate();
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [final_price]);

  const make_agree = () => {
    setAgree((prevState) => !prevState);
    const data = new FormData();
    data.append("nego_id", details?.nego_id);
    data.append("agree", agree);
    api
      .post("/account/agree/on/price", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        negotiate();
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const negotiate = () => {
    const data = new FormData();
    data.append("order_id", order_id);
    api
      .post("/account/open/negotiation", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setChats(response.data?.Chats);
        setDetails(response.data?.details);
        setHeader_Details(response.data?.header_details);
        setUimage(response.data?.user_image);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const fetchImage = () => {
    api
      .get("/users/su", {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setPersonaInfo(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const negotiate_chats = () => {
    const data = new FormData();
    data.append("order_id", order_id);
    api
      .post("/account/open/negotiation", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setChats(response.data?.Chats);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    negotiate_chats();
    // const intervalId = setInterval(negotiate_chats, 2000);
    // return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    negotiate();
    fetchImage();
  }, [order_id]);

  const sendMessage = (event) => {
    event.preventDefault();
    const data = new FormData();
    data.append("nego_id", details.nego_id);
    data.append("message", message);

    api
      .post("/account/send/message", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        negotiate_chats();
        setMessage("");
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "480px",
    maxHeight: "550vh",
    overflowY: "auto",
    bgcolor: "#edede9",
    borderRadius: "7px",
    boxShadow: 24,
    p: 2,
  };

  const pic = (pic) => {
    const de = decode(pic);
    return `data:image/jpeg;base64,${btoa(de)}`;
  };

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <Box sx={style}>
        {details && details ? (
          <>
            <Box sx={{ marginRight: "auto" }}>
              <IconButton onClick={() => setUi()} color="error">
                <CancelIcon />
              </IconButton>
            </Box>
            <Box
              sx={{
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                backgroundColor: "#f1faee",
                borderTopLeftRadius: "7px",
                borderTopRightRadius: "7px",
                paddingTop: 2,
                paddingBottom: 2,
              }}
            >
              <Avatar
                alt={header_details?.username}
                src={pic(uimage)}
                sx={{ width: 65, height: 65 }}
              />
              <Typography variant="body2">
                <b>{header_details?.username}</b>
              </Typography>
              <Typography variant="body2">
                <b>{header_details?.warehouse}</b>
              </Typography>
            </Box>
            <Box
              sx={{
                mt: 1,
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography
                textAlign="center"
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              >
                <b>Aggreed Price: </b>
                <TextField
                  value={final_price}
                  onChange={(e) => setFinal_price(e.target.value)}
                  label="Final Price"
                  type="number"
                  size="small"
                  sx={{ ml: 1, borderRadius: 7 }}
                />
                <IconButton
                  color={agree === true ? "primary" : "success"}
                  onClick={make_agree}
                >
                  <CheckCircleIcon />
                </IconButton>
              </Typography>
            </Box>
            <Box sx={{ mt: 2, mb: 1, maxHeight: "40vh", overflow: "auto" }}>
              {chats &&
                chats
                  .slice()
                  .reverse()
                  .map((item) =>
                    item.username === fetchName() ? (
                      <MessageBox_com>
                        <div style={{ marginBottom: "3px" }}>
                          <Typography variant="subtitle">
                            <b style={{ marginRight: "5px" }}>You</b>
                            <FormatedDate value={item.datetime} />
                          </Typography>
                        </div>
                        <div>
                          <Typography>
                            <span>{item.message}</span>
                          </Typography>
                        </div>
                      </MessageBox_com>
                    ) : (
                      <MessageBox_goi>
                        <div style={{ marginBottom: "3px" }}>
                          <Typography variant="subtitle">
                            <b style={{ marginRight: "5px" }}>
                              {item.username}
                            </b>
                            <FormatedDate value={item.datetime} />
                          </Typography>
                        </div>
                        <div>
                          <Typography>
                            <span>{item.message}</span>
                          </Typography>
                        </div>
                      </MessageBox_goi>
                    )
                  )}
            </Box>
            <Box sx={{ display: "flex", flexDirection: "row" }}>
              <form onSubmit={sendMessage}>
                <TextField
                  required
                  size="small"
                  sx={{ borderRadius: 20, mt: 2, width: "360px" }}
                  placeholder="Type a message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
                <IconButton
                  sx={{ mt: 2, ml: "3px" }}
                  size="small"
                  onClick={sendMessage}
                  color="secondary"
                >
                  <SendIcon />
                </IconButton>
              </form>
            </Box>
          </>
        ) : (
          <CircularProgress />
        )}
      </Box>
    </Modal>
  );
};

const DetailsModal = ({ item }) => {
  const [open_mod, setOpen_mod] = useState(false);
  const [loading, setLoading] = useState(false);

  const [ui, setUi] = useState();
  // const [open, setOpen] = useState(false)

  const negotiate = () => {
    setUi(<ChatUI order_id={item.order_id} setUi={setUi} />);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "580px",
    maxHeight: "150vh",
    overflowY: "auto",
    bgcolor: "background.paper",
    border: "1px solid #e7ecef",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  const pic = (pic) => {
    const de = decode(pic);
    return `data:image/jpeg;base64,${btoa(de)}`;
  };

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  return (
    <>
      <Chip
        size="small"
        onClick={() => setOpen_mod(true)}
        sx={{
          margin: "4px",
          mt: 1,
          backgroundColor: item.order_type === "Sell" ? "#d90429" : "#3a0ca3",
        }}
        label={<b style={{ color: "#fff" }}>View details</b>}
      />
      <Modal
        open={open_mod}
        onClose={() => setOpen_mod(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {ui}
          <Grid container>
            <Grid item xs={12} md={12}>
              <Typography
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                variant="subtitle"
                sx={{ textAlign: "center" }}
              >
                <b>Order Details</b>
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                variant="subtitle"
                sx={{ textAlign: "center" }}
              >
                <b>{item.order_type === "Buy" ? "(Buying)" : "(Selling)"}</b>
              </Typography>
              <div style={{ display: "flex", marginTop: "5px" }}>
                <Typography
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  variant="subtitle"
                >
                  Commodity: <b>{item.commodity}</b>
                </Typography>
              </div>

              <div style={{ display: "flex", marginTop: "5px" }}>
                <Typography
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  variant="subtitle"
                >
                  Order date:{" "}
                  <b>
                    <FormatedDate value={item.date} />
                  </b>
                </Typography>
              </div>

              <div style={{ display: "flex", marginTop: "5px" }}>
                <Typography
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  variant="subtitle"
                >
                  Order type: <b>{item.order_type}</b>
                </Typography>
              </div>

              <div style={{ display: "flex", marginTop: "5px" }}>
                <Typography
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  variant="subtitle"
                >
                  Bags: <b>{item.bags}</b>
                </Typography>
              </div>

              <div style={{ display: "flex", marginTop: "5px" }}>
                <Typography
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  variant="subtitle"
                >
                  Grade: <b>{item.grade}</b>
                </Typography>
              </div>

              <div style={{ display: "flex", marginTop: "5px" }}>
                <Typography
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  variant="subtitle"
                >
                  Unit: <b>{item.unit}</b>
                </Typography>
              </div>
              <div style={{ display: "flex", marginTop: "5px" }}>
                <Typography
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  variant="subtitle"
                >
                  Note:
                  <div>
                    <b>{item.message}</b>
                  </div>
                </Typography>
              </div>

              {item.order_type === "Sell" ? (
                <div style={{ display: "flex", marginTop: "5px" }}>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="subtitle"
                  >
                    Selling Price:{" "}
                    <b>{currencyFormat.format(item.open_price)}</b>
                  </Typography>
                </div>
              ) : null}

              <div style={{ display: "flex", marginTop: "5px" }}>
                <Typography
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  variant="subtitle"
                >
                  {item.commodity} price on order date:
                  <div>
                    Grade A: <b>{currencyFormat.format(item.grade_a)}</b>
                  </div>
                  <div>
                    Grade B: <b>{currencyFormat.format(item.grade_b)}</b>
                  </div>
                  <div>
                    Grade C: <b>{currencyFormat.format(item.grade_c)}</b>
                  </div>
                </Typography>
              </div>
            </Grid>

            <Grid item xs={12} md={6}>
              <div style={{ display: "flex", marginTop: "5px" }}>
                <Avatar
                  sx={{ width: 65, height: 65 }}
                  alt={item.member_name}
                  src={pic(item.member_image)}
                />
              </div>

              <div style={{ display: "flex", marginTop: "5px" }}>
                <Typography
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  variant="subtitle"
                >
                  Member name: <b>{item.member_name}</b>
                </Typography>
              </div>

              <div style={{ display: "flex", marginTop: "5px" }}>
                <Typography
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  variant="subtitle"
                >
                  Member phone: <b>{item.member_phone}</b>
                </Typography>
              </div>

              <div style={{ display: "flex", marginTop: "5px" }}>
                <Typography
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  variant="subtitle"
                >
                  Community: <b>{item.community.community_name}</b>
                </Typography>
              </div>

              <div style={{ display: "flex", marginTop: "5px" }}>
                <Typography
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  variant="subtitle"
                >
                  Savings Group: <b>{item.association.association_name}</b>
                </Typography>
              </div>

              <div style={{ display: "flex", marginTop: "5px" }}>
                <Typography
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  variant="subtitle"
                >
                  Kind: <b>{item.kind.association_type}</b>
                </Typography>
              </div>

              <div style={{ display: "flex", marginTop: "5px" }}>
                <Typography
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  variant="subtitle"
                >
                  Cluster: <b>{item.cluster.cluster_name}</b>
                </Typography>
              </div>

              <div style={{ display: "flex", marginTop: "5px" }}>
                <Typography
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  variant="subtitle"
                >
                  Society: <b>{item.society.society}</b>
                </Typography>
              </div>

              <div style={{ display: "flex", marginTop: "5px" }}>
                <Typography
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  variant="subtitle"
                >
                  Warehouse: <b>{item.warehouse_details.warehouse}</b>
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12} md={12}>
              <Button
                size="small"
                variant="contained"
                color="success"
                sx={{ mr: "4px" }}
                onClick={negotiate}
              >
                {loading === true ? (
                  <CircularProgress size={15} />
                ) : (
                  "Negotiate"
                )}
              </Button>

              <Button
                size="small"
                variant="contained"
                color="error"
                onClick={() => setOpen_mod(false)}
              >
                Close
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
};

const Item_order_buy = styled(Paper)(({ theme }) => ({
  backgroundColor: "#3a0ca3",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  margin: "4px",
  display: "flex",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2), 0 4px 10px rgba(0, 0, 0, 0.2)",
  borderRadius: "20px",
}));

const Item_order_sell = styled(Paper)(({ theme }) => ({
  backgroundColor: "#d90429",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  margin: "4px",
  display: "flex",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2), 0 4px 10px rgba(0, 0, 0, 0.2)",
  borderRadius: "20px",
}));

const CommodityInside = (props) => {
  const [current_prices, setCurrent_prices] = useState([]);
  const [available_units, setAvailable_units] = useState([]);
  const [more_details, setMore_details] = useState([]);
  const [price_tracked, setPrice_tracked] = useState([]);
  const [acts_all, setActs_all] = useState([]);
  const [total_cash_value, setTotal_cash_value] = useState();
  const [total_bags, setTotal_bags] = useState();
  const [total_balance, setTotal_balance] = useState();
  const [start_date_all, setStart_date_all] = useState("");
  const [end_date_all, setEnd_date_all] = useState("");
  const [mini_loading, setMini_loading] = useState(false);
  const [charges, setCharges] = useState([]);
  const [confirm_request_all, setConfirm_request_all] = useState([]);
  const [processingComplete_all, setProcessingComplete_all] = useState(false);
  const [fees, setFees] = useState([]);
  const [modal_Open_no_all, setModal_open_no_all] = useState(false);
  const [modal_Open_no_ret_all, setModal_open_no_ret_all] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    api
      .get(`/account/commodities/charges/${props.warehouse_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setCharges(response.data);
      });
  }, []);

  const fetch_activities_all = () => {
    const info = new FormData();
    info.append("warehouse_id", props.warehouse_id);
    info.append("commodity_id", props.commodity_id);
    info.append("start_date", start_date_all);
    info.append("end_date", end_date_all);
    info.append("grade", '');
    info.append("unit", '');

    api
      .post("/commodity/commodity/activities/commodity/yeah", info, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setActs_all(response.data?.activities);
        setTotal_cash_value(response.data?.total_cash_value);
        setTotal_bags(response.data?.total_bags);
        setTotal_balance(response.data?.total_balance);
      });
  };

  useEffect(() => {
    fetch_activities_all();
  }, []);

  useEffect(() => {
    fetch_activities_all();
  }, [props]);

  const clear_filter_all = () => {
    setStart_date_all("");
    setEnd_date_all("");
    fetch_all_activities();
  };

  const visitMember = ({ params }) => {
    navigate("/onemember/", {
      state: {
        Member_id: params.row.member_id,
        Fullname: `${params.row.firstname} ${params.row.lastname}`,
      },
    });
  };

  const columns_all = [
    {
      field: "goto",
      type: "actions",
      headerName: "Visit",
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
          icon={<PersonIcon />}
          onClick={() => visitMember({ params })}
          label="View"
        />,
      ],
    },
    {
      field: "id",
      headerName: "Id",
      flex: 1,
    },

    {
      field: "member_id",
      headerName: "Member id",
      flex: 1,
    },
    {
      field: "account_id",
      headerName: "Account Id",
      flex: 1,
    },
    {
      field: "transaction_id",
      headerName: "Id",
      flex: 1,
    },
    {
      field: "firstname",
      headerName: "firstname",
      flex: 1,
    },
    {
      field: "lastname",
      headerName: "lastname",
      flex: 1,
    },
    {
      field: "fullname",
      headerName: "Member",
      flex: 1,
      renderCell: (params) => (
        <div>
          {params.row.firstname} {params.row.lastname}
        </div>
      ),
    },
    {
      field: "passbook_id",
      headerName: "Passbook",
      flex: 1,
    },
    {
      field: "transaction_date",
      headerName: "DateTime",
      flex: 1,
      renderCell: (params) => (
        <FormatedDate value={params.row.transaction_date} />
      ),
    },
    {
      field: "commodity",
      headerName: "Commodity",
      flex: 1,
    },
    {
      field: "transaction_type_id",
      headerName: "Act",
      flex: 1,
      renderCell: (params) =>
        params.row.transaction_type_id === 1 ? "Store" : "Retrieve",
    },
    {
      field: "amount_of_commodity",
      headerName: "Bags",
      flex: 1,
    },
    {
      field: "retriv_bags",
      headerName: "Bags left",
      flex: 1,
    },
    {
      field: "cash_value",
      headerName: "Cash value(GHS)",
      flex: 1,
      renderCell: (params) => currencyFormat.format(params.row.cash_value),
    },
    {
      field: "grade",
      headerName: "Grade",
      flex: 1,
    },
    {
      field: "unit_per_kg",
      headerName: "Units(kg)",
      flex: 1,
    },
    {
      field: "username",
      headerName: "Prepared by",
      flex: 1,
    },
    {
      field: "association_name",
      headerName: "Savings Group",
      flex: 1,
    },
    {
      field: "association_type",
      headerName: "Savings Group Kind",
      flex: 1,
    },
    {
      field: "total_cash_balance",
      headerName: "Cash Balance",
      flex: 1,
      renderCell: (params) =>
        currencyFormat.format(params.row.total_cash_balance),
    },
    {
      field: "view",
      type: "actions",
      width: 20,
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
          icon={<SummarizeIcon />}
          onClick={() => handle_print_all({ params })}
          label="View"
        />,
      ],
    },
    {
      field: "delete",
      type: "actions",
      width: 20,
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
          icon={<DeleteIcon />}
          onClick={() => handleClickOpen(params.row.transaction_id)}
          label="Open"
        />,
      ],
    },
  ];

  const [date, setDate] = useState();

  const handle_print_all = async ({ params }) => {
    setMini_loading(true);
    setDate(params.row.transaction_date);
    await proccess_info_all({ params });
  };

  const [member_fullname, setMember_fullname] = useState("");
  const [member_passbook_id, setMember_passbook_id] = useState("");
  const [member_association_type, setMember_association_type] = useState("");
  const [member_association_name, setMember_association_name] = useState("");

  const proccess_info_all = ({ params }) => {
    api
      .get(`/account/act/details/edit/${params.row.transaction_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setFees(response.data?.details);
        setMember_fullname(
          <div>
            {params.row.firstname} {params.row.lastname}
          </div>
        );
        setMember_passbook_id(params.row.passbook_id);
        setMember_association_type(params.row.association_type);
        setMember_association_name(params.row.association_name);
        const data = new FormData();
        data.append("commodity_id", params.row.id);
        data.append("grade_id", response.data?.details.grade_id);
        data.append("unit_id", response.data?.details.units_id);
        data.append(
          "amount_storing",
          response.data?.details.amount_of_commodity
        );
        data.append("member_com_acc", params.row.account_id);
        data.append("rebag", response.data?.details.rebagging_fee);
        data.append("stack", response.data?.details.stacking_fee);
        data.append("clean", response.data?.details.cleaning_fee);
        data.append("destone", response.data?.details.destoning_fee);
        data.append("store", response.data?.details.storage_fee);
        data.append("stitch", response.data?.details.stitching_fee);
        data.append("load", response.data?.details.loading_fee);
        data.append("empty_sack", response.data?.details.empty_sack_cost_fee);
        api
          .post("/account/process/storage", data, {
            headers: {
              Authorization: "Bearer " + fetchToken(),
            },
          })
          .then(function (response) {
            setConfirm_request_all(response.data);
            setProcessingComplete_all(true);
            if (params.row.transaction_type_id === 2) {
              setModal_open_no_ret_all(true);
            } else {
              setModal_open_no_all(true);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const closeam_all = () => {
    setMini_loading(false);
    setModal_open_no_all(false);
  };

  const handle_modal_Closee_ret_all = () => {
    setModal_open_no_ret_all(false);
  };

  const printRef = React.useRef();
  const printRef_ret = React.useRef();

  const handlePrint = async () => {
    const element = printRef.current;
    const canvas = await html2canvas(element);
    const data = canvas.toDataURL("image/png");

    const pdf = new jsPDF();
    const imgProperties = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;

    const marginLeft = 25;
    const marginTop = 25;
    const marginRight = 25;
    const marginBottom = 25;

    pdf.addImage(
      data,
      "PNG",
      marginLeft,
      marginTop,
      pdfWidth - marginLeft - marginRight,
      pdfHeight - marginTop - marginBottom
    );

    pdf.save("CommodityStorage.pdf");
    setMini_loading(false);
    setModal_open_no_all(false);
  };

  const handlePrint_ret = async () => {
    const element = printRef_ret.current;
    const canvas = await html2canvas(element);
    const data = canvas.toDataURL("image/png");

    const pdf = new jsPDF();
    const imgProperties = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;

    const marginLeft = 25;
    const marginTop = 25;
    const marginRight = 25;
    const marginBottom = 25;

    pdf.addImage(
      data,
      "PNG",
      marginLeft,
      marginTop,
      pdfWidth - marginLeft - marginRight,
      pdfHeight - marginTop - marginBottom
    );

    pdf.save("CommodityRetrieval.pdf");
    setMini_loading(false);
    setModal_open_no_ret_all(false);
  };

  const sec_style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 620,
    maxHeight: "80vh",
    overflowY: "auto",
    bgcolor: "background.paper",
    border: "1px solid #e7ecef",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  const fetch_all_prices = () => {
    api
      .get(`/commodity/price/track/intelligence/${props.commodity_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setPrice_tracked(response.data?.prices);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    api
      .get(`/account/current/prices/${props.commodity_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setCurrent_prices(response.data?.price);
        setAvailable_units(response.data?.units);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [props]);

  const fetch_details = () => {
    const feed = new FormData();
    feed.append("commodity_acc", props.warehouse_id);
    feed.append("commodity_id", props.commodity_id);

    api
      .post("/account/commodity/info/in/warehouse", feed, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setMore_details(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    fetch_all_prices();
    // const intervalId = setInterval(fetch_all_prices, 5000);
    // return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    fetch_details();
    // const intervalId = setInterval(fetch_details, 5000);
    // return () => clearInterval(intervalId);
  }, []);

  const pic = (pic) => {
    const de = decode(pic);
    return `data:image/jpeg;base64,${btoa(de)}`;
  };

  return (
    <>
      <Itemb>
        <Grid container>
          <Grid item xs={12} md={12}>
            <Typography
              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              variant="h5"
              sx={{ textAlign: "center" }}
            >
              <b>{props.commodity}</b>
            </Typography>
            <Divider variant="middle" sx={{ mt: 1, mb: 1 }}>
              {props.commodity} general details
            </Divider>
          </Grid>
          <Grid item xs={12} md={3}>
            <Box sx={{ display: "flex" }}>
              <div style={{ display: "block", margin: 1 }}>
                <Typography
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  variant="body"
                >
                  <b>Current Prices</b>
                </Typography>
                {current_prices &&
                  current_prices.map((item) => (
                    <Chip
                      key={item.id}
                      label={
                        <b>
                          <i>{`${item.grade}: ${currencyFormat.format(
                            item.price_per_kg
                          )}/kg`}</i>
                        </b>
                      }
                      size="small"
                      variant="outlined"
                      sx={{ color: "#000", m: 1 }}
                    />
                  ))}
              </div>
              <div style={{ display: "block", margin: 2 }}>
                <Typography
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  variant="body"
                >
                  <b>Available Units</b>
                </Typography>
                {available_units &&
                  available_units.map((item) => (
                    <Chip
                      key={item.id}
                      label={
                        <b>
                          <i>{`${item.units}kg`}</i>
                        </b>
                      }
                      size="small"
                      variant="outlined"
                      sx={{ color: "#000", m: 1 }}
                    />
                  ))}
              </div>
            </Box>
          </Grid>

          <Grid item xs={12} md={8}>
            <Itembf>
              <Typography variant="h5" fontStyle="oblique" textAlign="center">
                Prices
              </Typography>
              <Box sx={{ display: "flex" }}>
                <Typography sx={{ mr: 14, ml: 2 }}>
                  <b>DateTime</b>
                </Typography>
                <Typography sx={{ mr: 8 }}>
                  <b>Grade</b>
                </Typography>
                <Typography sx={{ mr: 6 }}>
                  <b>Movement</b>
                </Typography>
                <Typography sx={{ mr: 8 }}>
                  <b>Price</b>
                </Typography>
                <Typography sx={{ mr: 4 }}>
                  <b>Percentage</b>
                </Typography>
                <Typography sx={{ mr: 10 }}>
                  <b>Intavals</b>
                </Typography>
                <IconButton onClick={fetch_all_prices}>
                  <RefreshIcon />
                </IconButton>
              </Box>
              <Box style={{ overflowY: "auto", maxHeight: "120px" }}>
                {price_tracked.map((item) => (
                  <Itembd>
                    <Box sx={{ display: "flex" }}>
                      <Typography sx={{ mr: 5 }}>
                        <b>
                          <FormatedDate value={item.date} />
                        </b>
                      </Typography>
                      <Typography sx={{ mr: 10 }}>
                        <b>{item.grade}</b>
                      </Typography>
                      <Typography
                        sx={{ mr: 8 }}
                        color={
                          item.movement === "Increased"
                            ? "green"
                            : item.movement === "Decreased"
                            ? "red"
                            : "black"
                        }
                      >
                        <b>
                          {item.movement === "Increased" ? (
                            <ArrowUpward />
                          ) : item.movement === "Decreased" ? (
                            <ArrowDownwardIcon />
                          ) : (
                            <IndeterminateCheckBoxOutlinedIcon />
                          )}
                        </b>
                      </Typography>

                      <Typography
                        sx={{ mr: 9 }}
                        color={
                          item.movement === "Increased"
                            ? "green"
                            : item.movement === "Decreased"
                            ? "red"
                            : "black"
                        }
                      >
                        <b>{currencyFormat.format(item.price)}</b>
                      </Typography>

                      <Typography
                        sx={{ mr: 9 }}
                        color={
                          item.movement === "Increased"
                            ? "green"
                            : item.movement === "Decreased"
                            ? "red"
                            : "black"
                        }
                      >
                        <b>{item.percentage_on_movement}%</b>
                      </Typography>

                      <Typography
                        sx={{ mr: 3 }}
                        color={
                          item.movement === "Increased"
                            ? "green"
                            : item.movement === "Decreased"
                            ? "red"
                            : "black"
                        }
                      >
                        <b>
                          {item.date_difference}{" "}
                          {item.date_difference <= 1 ? "day" : "days"}
                        </b>
                      </Typography>
                    </Box>
                  </Itembd>
                ))}
              </Box>
            </Itembf>
          </Grid>

          <Grid item xs={12} md={12}>
            <Divider variant="middle" sx={{ mt: 1, mb: 1 }}>
              {props.warehouse_name} {props.commodity} details
            </Divider>
          </Grid>

          <Grid
            item
            xs={12}
            md={12}
            sx={{ ml: 2, padding: 1, borderRadius: 5 }}
          >
            <Typography
              align="left"
              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              variant="body1"
            >
              Total Number of bags:{" "}
              <b style={{ color: "#000" }}>{more_details.total_bags}</b>
            </Typography>
          </Grid>

          <Grid item xs={12} md={12}>
            <Divider variant="middle" sx={{ mt: 1, mb: 1 }}>
              Activities
            </Divider>
          </Grid>

          <Grid
            item
            xs={12}
            md={12}
            sx={{ ml: 2, padding: 1, borderRadius: 5 }}
          >
            <Box sx={{ maxHeight: 530, overflow: "auto" }}>
              <Typography
                variant="button"
                display="block"
                gutterBottom
                textAlign="center"
              >
                <b>Activities in warehouse</b>
              </Typography>
              <Typography variant="button" display="block">
                Commodity: <b style={{ color: "black" }}>{props.commodity}</b>
              </Typography>
              <>
                <Typography>Filter Date</Typography>
                <div style={{ display: "flex" }}>
                  <TextField
                    type="date"
                    size="small"
                    required
                    variant="outlined"
                    helperText="From"
                    name="start_date_all"
                    onChange={(e) => setStart_date_all(e.target.value)}
                    value={start_date_all}
                    sx={{ mr: 1 }}
                  />

                  <TextField
                    type="date"
                    size="small"
                    required
                    variant="outlined"
                    helperText="To"
                    name="end_date_all"
                    onChange={(e) => setEnd_date_all(e.target.value)}
                    value={end_date_all}
                    sx={{ mr: 1 }}
                  />

                  <IconButton sx={{ mb: 2 }} onClick={fetch_activities_all}>
                    <FilterAltOutlinedIcon />
                  </IconButton>
                  <IconButton sx={{ mb: 2 }} onClick={clear_filter_all}>
                    <CancelIcon />
                  </IconButton>
                </div>
              </>
              <Box sx={{ mb: 7 }}>
                <DataGrid
                  rows={acts_all}
                  columns={columns_all}
                  autoHeight
                  loading={mini_loading}
                  checkboxSelection
                  getRowId={(row) => row.transaction_id}
                  sortingOrder={["desc", "asc"]}
                  sortModel={[
                    {
                      field: "transaction_id",
                      sort: "desc",
                    },
                  ]}
                  slots={{ toolbar: GridToolbar }}
                  initialState={{
                    pagination: { paginationModel: { pageSize: 6 } },
                    columns: {
                      columnVisibilityModel: {
                        transaction_id: false,
                        id: false,
                        association_type: false,
                        lastname: false,
                        firstname: false,
                        account_id: false,
                        commodity: false,
                        member_id: false,
                      },
                    },
                  }}
                  pageSizeOptions={[6, 10, 25]}
                />
                <div>
                  <div style={{ display: "flex", padding: "4px" }}>
                    <Typography variant="h6" sx={{ mr: 4 }}>
                      <b>Total:</b>
                    </Typography>
                    <Typography variant="h6" sx={{ mr: 4 }}>
                      <b>
                        Cash Value: {currencyFormat.format(total_cash_value)}
                      </b>{" "}
                    </Typography>
                    <Typography variant="h6" sx={{ mr: 4 }}>
                      <b>Bags: {total_bags}</b>{" "}
                    </Typography>
                    <Typography variant="h6" sx={{ mr: 4 }}>
                      <b>
                        Cash Balance: {currencyFormat.format(total_balance)}
                      </b>{" "}
                    </Typography>
                  </div>
                </div>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Itemb>

      <Modal
        open={modal_Open_no_all}
        onClose={closeam_all}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        {confirm_request_all ? (
          <Box sx={sec_style}>
            <>
              <div ref={printRef} style={{ display: "block", marginBottom: 5 }}>
                <Typography
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  variant="body2"
                  sx={{ textAlign: "center", mb: 2 }}
                >
                  ~The Cooperative~
                </Typography>

                <Typography
                  variant="h5"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  Commodity Storage
                </Typography>
                <Chip
                  sx={{ display: "flex", mt: 1, mb: 1 }}
                  label={confirm_request_all.Commodity}
                  variant="outlined"
                  color="success"
                />
                <Divider variant="middle" sx={{ mt: 1, mb: 1 }}>
                  <i>Member Details</i>
                </Divider>

                <div>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                  >
                    Date:{" "}
                    <b style={{ color: "black" }}>
                      {" "}
                      <FormatedDate value={date} />
                    </b>
                  </Typography>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                  >
                    Member: <b style={{ color: "black" }}>{member_fullname}</b>
                  </Typography>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                  >
                    Passbook:{" "}
                    <b style={{ color: "black" }}>{member_passbook_id}</b>
                  </Typography>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                  >
                    Society:{" "}
                    <b style={{ color: "black" }}>{props.society_name}</b>
                  </Typography>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                  >
                    Kind:{" "}
                    <b style={{ color: "black" }}>{member_association_type}</b>
                  </Typography>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                  >
                    Savings Group:{" "}
                    <b style={{ color: "black" }}>{member_association_name}</b>
                  </Typography>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                  >
                    Warehouse:{" "}
                    <b style={{ color: "black" }}>{props.warehouse_name}</b>
                  </Typography>
                </div>

                <Divider variant="middle" sx={{ mt: 2, mb: 2 }}>
                  <i>Commodity Specification</i>
                </Divider>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div style={{ display: "block" }}>
                    <Typography
                      variant="h6"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      Grade: <b>{confirm_request_all.Grade}</b>{" "}
                    </Typography>
                    <Typography
                      variant="h6"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      Current {confirm_request_all.Commodity} price:{" "}
                      <b>
                        {currencyFormat.format(
                          confirm_request_all.Current_commodity_price
                        )}
                      </b>{" "}
                    </Typography>
                    <Typography
                      variant="h6"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      Number of Bags:{" "}
                      <b>{confirm_request_all.Amount_storing} </b>{" "}
                    </Typography>
                    <Typography
                      variant="h6"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      Units: <b>{confirm_request_all.Unit_kg}kg</b>{" "}
                    </Typography>
                    <Typography
                      variant="h6"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      Weight: <b>{confirm_request_all.Weight}kg </b>{" "}
                    </Typography>
                    <Typography
                      variant="h6"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      Tonnes: <b>{confirm_request_all.Tons}</b>{" "}
                    </Typography>
                    <Typography
                      variant="h6"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      Price per bag (Original):{" "}
                      <b>
                        {currencyFormat.format(
                          confirm_request_all.Price_per_bag
                        )}
                      </b>{" "}
                    </Typography>
                    <Typography
                      variant="h6"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      Price per bag (Charged):{" "}
                      <b>
                        {currencyFormat.format(
                          confirm_request_all.charged_price_per_bg
                        )}
                      </b>{" "}
                    </Typography>
                    <Typography
                      variant="h6"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      Current cash value:{" "}
                      <b>
                        {currencyFormat.format(
                          confirm_request_all.total_cash_value
                        )}
                      </b>{" "}
                    </Typography>
                  </div>
                  <div
                    style={{
                      display: "block",
                      marginLeft: "3px",
                      borderColor: "blue",
                    }}
                  >
                    {charges[0] ? (
                      <>
                        <Typography
                          variant="subtitle"
                          fontStyle="oblique"
                          fontFamily="Futura"
                        >
                          <b>
                            <u>Charges associated</u>
                          </b>
                        </Typography>
                        <Typography
                          variant="h6"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          Rebag (
                          {currencyFormat.format(charges[0].rebagging_fee)}):{" "}
                          <b>
                            {fees.rebagging_fee === true
                              ? "paid"
                              : "no rebaging"}
                          </b>{" "}
                        </Typography>
                        <Typography
                          variant="h6"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          Stack (
                          {currencyFormat.format(charges[0].stacking_fee)}):{" "}
                          <b>
                            {fees.stacking_fee === true
                              ? "paid"
                              : "no stacking"}
                          </b>{" "}
                        </Typography>
                        <Typography
                          variant="h6"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          Clean (
                          {currencyFormat.format(charges[0].cleaning_fee)}):{" "}
                          <b>
                            {fees.cleaning_fee === true
                              ? "paid"
                              : "no cleaning"}
                          </b>{" "}
                        </Typography>
                        <Typography
                          variant="h6"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          Destone (
                          {currencyFormat.format(charges[0].destoning_fee)}):{" "}
                          <b>
                            {fees.destone === true ? "paid" : "no destoning"}
                          </b>{" "}
                        </Typography>
                        <Typography
                          variant="h6"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          Store ({currencyFormat.format(charges[0].storage_fee)}
                          ):{" "}
                          <b>
                            {fees.storage_fee === true
                              ? "paid"
                              : "no storage_fee"}
                          </b>{" "}
                        </Typography>
                        <Typography
                          variant="h6"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          Stitch (
                          {currencyFormat.format(charges[0].stitching_fee)}):{" "}
                          <b>
                            {fees.stitching_fee === true
                              ? "paid"
                              : "no stitching"}
                          </b>{" "}
                        </Typography>
                        <Typography
                          variant="h6"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          Load ({currencyFormat.format(charges[0].loading_fee)}
                          ):{" "}
                          <b>
                            {fees.loading_fee === true ? "paid" : "no loading"}
                          </b>{" "}
                        </Typography>
                        <Typography
                          variant="h6"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          Empty Sack (
                          {currencyFormat.format(
                            charges[0].empty_sack_cost_fee
                          )}
                          ):{" "}
                          <b>
                            {fees.empty_sack_cost_fee === true
                              ? "paid"
                              : "no empty sack"}
                          </b>{" "}
                        </Typography>
                        <Typography
                          variant="h6"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          Tax ({currencyFormat.format(charges[0].tax_fee)}):{" "}
                          <b>paid</b>{" "}
                        </Typography>
                      </>
                    ) : (
                      <Box sx={{ width: "100%", justifyContent: "center" }}>
                        <CircularProgress size="15" />
                      </Box>
                    )}
                  </div>
                </div>
              </div>
              <Typography
                sx={{ mt: 2 }}
                variant="subtitle"
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              >
                Print:
              </Typography>
              <IconButton onClick={handlePrint}>
                <SummarizeIcon size="small" />
              </IconButton>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginLeft: 320,
                }}
              >
                <Button
                  variant="contained"
                  onClick={closeam_all}
                  color="error"
                  size="small"
                  sx={{ mr: 1 }}
                >
                  Cancel
                </Button>
              </div>
            </>
          </Box>
        ) : (
          <Box sx={{ width: "100%", justifyContent: "center" }}>
            <CircularProgress size="15" />
          </Box>
        )}
      </Modal>

      {/* retriva */}
      <Modal
        open={modal_Open_no_ret_all}
        onClose={handle_modal_Closee_ret_all}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        {confirm_request_all ? (
          <Box sx={sec_style}>
            <>
              <div
                ref={printRef_ret}
                style={{ display: "block", marginBottom: 5 }}
              >
                <Typography
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  variant="body2"
                  sx={{ textAlign: "center", mb: 2 }}
                >
                  ~The Cooperative~
                </Typography>

                <Typography
                  variant="h5"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  Commodity Retrieval
                </Typography>
                <Chip
                  sx={{ display: "flex", mt: 1, mb: 1 }}
                  label={confirm_request_all.Commodity}
                  variant="outlined"
                  color="success"
                />
                <Divider variant="middle" sx={{ mt: 1, mb: 1 }}>
                  <i>Member Details</i>
                </Divider>

                <div>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                  >
                    Date:{" "}
                    <b style={{ color: "black" }}>
                      {" "}
                      <FormatedDate value={date} />
                    </b>
                  </Typography>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                  >
                    Member: <b style={{ color: "black" }}>{member_fullname}</b>
                  </Typography>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                  >
                    Passbook:{" "}
                    <b style={{ color: "black" }}>{member_passbook_id}</b>
                  </Typography>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                  >
                    Society:{" "}
                    <b style={{ color: "black" }}>{props.society_name}</b>
                  </Typography>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                  >
                    Kind:{" "}
                    <b style={{ color: "black" }}>{member_association_type}</b>
                  </Typography>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                  >
                    Savings Group:{" "}
                    <b style={{ color: "black" }}>{member_association_name}</b>
                  </Typography>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                  >
                    Warehouse:{" "}
                    <b style={{ color: "black" }}>{props.warehouse_name}</b>
                  </Typography>
                </div>

                <Divider variant="middle" sx={{ mt: 2, mb: 2 }}>
                  <i>Commodity Specification</i>
                </Divider>

                <Typography
                  variant="h6"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  Grade: <b>{confirm_request_all.Grade}</b>{" "}
                </Typography>
                <Typography
                  variant="h6"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  Current {confirm_request_all.Commodity} price:{" "}
                  <b>
                    {currencyFormat.format(
                      confirm_request_all.Current_commodity_price
                    )}
                  </b>{" "}
                </Typography>
                <Typography
                  variant="h6"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  Bags retrieving: <b>{confirm_request_all.Amount_storing} </b>{" "}
                </Typography>
                <Typography
                  variant="h6"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  Units: <b>{confirm_request_all.Unit_kg}kg</b>{" "}
                </Typography>
                <Typography
                  variant="h6"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  Weight: <b>{confirm_request_all.Weight}kg </b>{" "}
                </Typography>
                <Typography
                  variant="h6"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  Tonnes: <b>{confirm_request_all.Tons}</b>{" "}
                </Typography>
                <Typography
                  variant="h6"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  Price per bag (Charged):{" "}
                  <b>
                    {currencyFormat.format(confirm_request_all.Price_per_bag)}
                  </b>{" "}
                </Typography>
                <Typography
                  variant="h6"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  Value:{" "}
                  <b>
                    {currencyFormat.format(
                      confirm_request_all.total_cash_value
                    )}
                  </b>{" "}
                </Typography>
              </div>
              <Typography
                sx={{ mt: 2 }}
                variant="subtitle"
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              >
                Print:
              </Typography>
              <IconButton onClick={handlePrint_ret}>
                <SummarizeIcon size="small" />
              </IconButton>

              <Button
                variant="contained"
                onClick={handle_modal_Closee_ret_all}
                color="error"
                size="small"
                sx={{ mr: 1 }}
              >
                Cancel
              </Button>
            </>
          </Box>
        ) : (
          <Box sx={{ width: "100%", justifyContent: "center" }}>
            <CircularProgress size="15" />
          </Box>
        )}
      </Modal>
    </>
  );
};

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2), 0 4px 10px rgba(0, 0, 0, 0.2)",
  borderRadius: "20px",
}));

const Itemb = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  // textAlign: 'center',
  color: theme.palette.text.secondary,
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2), 0 4px 10px rgba(0, 0, 0, 0.2)",
  borderRadius: "20px",
}));

const Itembd = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  // textAlign: 'center',
  color: theme.palette.text.secondary,
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2), 0 4px 10px rgba(0, 0, 0, 0.2)",
  borderRadius: "20px",
  margin: "10px",
}));

const Itembf = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  // textAlign: 'center',
  color: theme.palette.text.secondary,
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2), 0 4px 10px rgba(0, 0, 0, 0.2)",
  borderRadius: "20px",
  margin: "50px",
}));

const Itemba = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  marginTop: "5px",
  color: theme.palette.text.secondary,
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2), 0 4px 10px rgba(0, 0, 0, 0.2)",
  borderRadius: "20px",
}));

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const MemberInside = ({
  warehouse_name,
  warehouse_id,
  name,
  image,
  member_id,
  commodities,
  passbook_id,
  association_name,
  cash_value,
  account_id,
  association_id,
  association_type,
  society_name,
}) => {
  const [acts_all, setActs_all] = useState([]);
  const [total_cash_value, setTotal_cash_value] = useState();
  const [total_bags, setTotal_bags] = useState();
  const [total_balance, setTotal_balance] = useState();
  const [start_date_all, setStart_date_all] = useState("");
  const [end_date_all, setEnd_date_all] = useState("");
  const [mini_loading, setMini_loading] = useState(false);
  const [charges, setCharges] = useState([]);
  const [confirm_request_all, setConfirm_request_all] = useState([]);
  const [processingComplete_all, setProcessingComplete_all] = useState(false);
  const [fees, setFees] = useState([]);
  const [modal_Open_no_all, setModal_open_no_all] = useState(false);
  const [modal_Open_no_ret_all, setModal_open_no_ret_all] = useState(false);
  const navigate = useNavigate();

  const fetch_activities_all = () => {
    const info = new FormData();
    info.append("member_com_acc_id", account_id);
    info.append("start_date", start_date_all);
    info.append("end_date", end_date_all);

    api
      .post("/account/my/activities/commodity", info, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setActs_all(response.data?.activities);
        setTotal_cash_value(response.data?.total_cash_value);
        setTotal_bags(response.data?.total_bags);
        setTotal_balance(response.data?.total_balance);
      });
  };

  useEffect(() => {
    fetch_activities_all();
  }, []);

  useEffect(() => {
    fetch_activities_all();
  }, [account_id]);

  const columns_all = [
    {
      field: "id",
      headerName: "Id",
      flex: 1,
    },
    {
      field: "transaction_id",
      headerName: "Id",
      flex: 1,
    },
    {
      field: "transaction_date",
      headerName: "DateTime",
      flex: 1,
      renderCell: (params) => (
        <FormatedDate value={params.row.transaction_date} />
      ),
    },
    {
      field: "commodity",
      headerName: "Commodity",
      flex: 1,
    },
    {
      field: "amount_of_commodity",
      headerName: "Bags Stored",
      flex: 1,
    },
    {
      field: "cash_value",
      headerName: "Cash value(GHS)",
      flex: 1,
      renderCell: (params) => currencyFormat.format(params.row.cash_value),
    },
    {
      field: "transaction_type_id",
      headerName: "Act",
      flex: 1,
      renderCell: (params) =>
        params.row.transaction_type_id === 1 ? "Store" : "Retrieve",
    },
    {
      field: "grade",
      headerName: "Grade",
      flex: 1,
    },
    {
      field: "unit_per_kg",
      headerName: "Units(kg)",
      flex: 1,
    },
    {
      field: "username",
      headerName: "Prepared by",
      flex: 1,
    },
    {
      field: "total_cash_balance",
      headerName: "Cash Balance",
      flex: 1,
      renderCell: (params) =>
        currencyFormat.format(params.row.total_cash_balance),
    },
    {
      field: "view",
      type: "actions",
      width: 20,
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
          icon={<SummarizeIcon />}
          onClick={() => handle_print_all({ params })}
          label="View"
        />,
      ],
    },
    {
      field: "delete",
      type: "actions",
      width: 20,
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
          icon={<DeleteIcon />}
          onClick={() => handleClickOpen(params.row.transaction_id)}
          label="Open"
        />,
      ],
    },
  ];

  const [date, setDate] = useState();

  const handle_print_all = async ({ params }) => {
    setMini_loading(true);
    setDate(params.row.transaction_date);
    await proccess_info_all({ params });
  };

  const proccess_info_all = ({ params }) => {
    api
      .get(`/account/act/details/edit/${params.row.transaction_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setFees(response.data?.details);
        const data = new FormData();
        data.append("commodity_id", params.row.id);
        data.append("grade_id", response.data?.details.grade_id);
        data.append("unit_id", response.data?.details.units_id);
        data.append(
          "amount_storing",
          response.data?.details.amount_of_commodity
        );
        data.append("member_com_acc", account_id);
        data.append("rebag", response.data?.details.rebagging_fee);
        data.append("stack", response.data?.details.stacking_fee);
        data.append("clean", response.data?.details.cleaning_fee);
        data.append("destone", response.data?.details.destoning_fee);
        data.append("store", response.data?.details.storage_fee);
        data.append("stitch", response.data?.details.stitching_fee);
        data.append("load", response.data?.details.loading_fee);
        data.append("empty_sack", response.data?.details.empty_sack_cost_fee);
        api
          .post("/account/process/storage", data, {
            headers: {
              Authorization: "Bearer " + fetchToken(),
            },
          })
          .then(function (response) {
            setConfirm_request_all(response.data);
            setProcessingComplete_all(true);
            if (params.row.transaction_type_id === 2) {
              setModal_open_no_ret_all(true);
            } else {
              setModal_open_no_all(true);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const CustomFooterRow = () => {
    return (
      <div>
        <div style={{ display: "flex", padding: "4px" }}>
          <Typography variant="h6" sx={{ mr: 4 }}>
            <b>Total:</b>
          </Typography>
          <Typography variant="h6" sx={{ mr: 4 }}>
            <b>Cash Value: {currencyFormat.format(total_cash_value)}</b>{" "}
          </Typography>
          <Typography variant="h6" sx={{ mr: 4 }}>
            <b>Bags: {total_bags}</b>{" "}
          </Typography>
          <Typography variant="h6" sx={{ mr: 4 }}>
            <b>Cash Balance: {currencyFormat.format(total_balance)}</b>{" "}
          </Typography>
        </div>
      </div>
    );
  };

  const sec_style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 620,
    maxHeight: "80vh",
    overflowY: "auto",
    bgcolor: "background.paper",
    border: "1px solid #e7ecef",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  const clear_filter_all = () => {
    setStart_date_all("");
    setEnd_date_all("");
    fetch_activities_all();
  };

  const pic = (pic) => {
    const de = decode(pic);
    return `data:image/jpeg;base64,${btoa(de)}`;
  };

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  const visitAssociation = () => {
    api
      .get(`/association/${association_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        navigate("/association/", { state: { responseData: response.data } });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const visitMember = () => {
    navigate("/onemember/", {
      state: {
        Member_id: member_id,
        Fullname: name,
      },
    });
  };

  useEffect(() => {
    api
      .get(`/account/commodities/charges/${warehouse_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setCharges(response.data);
      });
  }, []);

  const closeam_all = () => {
    setMini_loading(false);
    setModal_open_no_all(false);
  };

  const handle_modal_Closee_ret_all = () => {
    setModal_open_no_ret_all(false);
  };

  const printRef = React.useRef();
  const printRef_ret = React.useRef();

  const handlePrint = async () => {
    const element = printRef.current;
    const canvas = await html2canvas(element);
    const data = canvas.toDataURL("image/png");

    const pdf = new jsPDF();
    const imgProperties = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;

    const marginLeft = 25;
    const marginTop = 25;
    const marginRight = 25;
    const marginBottom = 25;

    pdf.addImage(
      data,
      "PNG",
      marginLeft,
      marginTop,
      pdfWidth - marginLeft - marginRight,
      pdfHeight - marginTop - marginBottom
    );

    pdf.save("CommodityStorage.pdf");
    setMini_loading(false);
    setModal_open_no_all(false);
  };

  const handlePrint_ret = async () => {
    const element = printRef_ret.current;
    const canvas = await html2canvas(element);
    const data = canvas.toDataURL("image/png");

    const pdf = new jsPDF();
    const imgProperties = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;

    const marginLeft = 25;
    const marginTop = 25;
    const marginRight = 25;
    const marginBottom = 25;

    pdf.addImage(
      data,
      "PNG",
      marginLeft,
      marginTop,
      pdfWidth - marginLeft - marginRight,
      pdfHeight - marginTop - marginBottom
    );

    pdf.save("CommodityRetrieval.pdf");
    setMini_loading(false);
    setModal_open_no_ret_all(false);
  };

  return (
    <>
      <Itemb>
        <div style={{ display: "flex", margin: 4 }}>
          <Avatar
            alt={name}
            src={pic(image)}
            sx={{ width: 200, height: 200 }}
          />
          <div style={{ display: "block", margin: 5 }}>
            <Typography
              sx={{ m: 1 }}
              color="black"
              variant="h4"
              fontStyle="normal"
              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
            >
              <b>{name}</b>
            </Typography>
            <Typography
              sx={{ m: 1 }}
              color="black"
              textAlign="left"
              variant="h5"
              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
            >
              Passbook: <b> {passbook_id}</b>
              <Chip
                onClick={visitMember}
                sx={{ ml: 1, boxShadow: 1 }}
                size="small"
                color="secondary"
                startIcon={<LaunchIcon />}
                label={<b>Visit</b>}
              />
              <br></br>
              Savings Group: <b> {association_name} </b>{" "}
              <Chip
                onClick={visitAssociation}
                sx={{ ml: 1, boxShadow: 1 }}
                size="small"
                color="secondary"
                startIcon={<LaunchIcon />}
                label={<b>Visit</b>}
              />
              {"\n"}
              <br></br>
              Owned Commodities Worth:{" "}
              <b>{currencyFormat.format(cash_value)}</b>
            </Typography>

            <Box sx={{ minWidth: 280 }}>
              <Typography sx={{ m: 1 }} fontStyle="oblique" variant="subtitle">
                Commodities in store
              </Typography>
              <div style={{ overflowX: "auto", display: "flex" }}>
                {commodities ? (
                  commodities &&
                  commodities.map((items) => (
                    <Chip
                      color="success"
                      label={items.commodity}
                      sx={{ m: 1 }}
                    />
                  ))
                ) : (
                  <Typography
                    sx={{ m: 1 }}
                    color="black"
                    textAlign="left"
                    variant="body1"
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    No commodity stored at the moment
                  </Typography>
                )}
              </div>
            </Box>
          </div>
        </div>

        <Box sx={{ maxHeight: 530 }}>
          <Typography
            variant="button"
            display="block"
            gutterBottom
            textAlign="center"
          >
            <b>Activities</b>
          </Typography>
          <>
            <Typography>Filter Date</Typography>
            <div style={{ display: "flex" }}>
              <TextField
                type="date"
                size="small"
                required
                variant="outlined"
                helperText="From"
                name="start_date_all"
                onChange={(e) => setStart_date_all(e.target.value)}
                value={start_date_all}
                sx={{ mr: 1 }}
              />

              <TextField
                type="date"
                size="small"
                required
                variant="outlined"
                helperText="To"
                name="end_date_all"
                onChange={(e) => setEnd_date_all(e.target.value)}
                value={end_date_all}
                sx={{ mr: 1 }}
              />

              <IconButton sx={{ mb: 2 }} onClick={fetch_activities_all}>
                <FilterAltOutlinedIcon />
              </IconButton>
              <IconButton sx={{ mb: 2 }} onClick={clear_filter_all}>
                <CancelIcon />
              </IconButton>
            </div>
          </>
          <DataGrid
            rows={acts_all}
            columns={columns_all}
            loading={mini_loading}
            autoHeight
            checkboxSelection
            getRowId={(row) => row.transaction_id}
            sortingOrder={["desc", "asc"]}
            sortModel={[
              {
                field: "transaction_id",
                sort: "desc",
              },
            ]}
            slots={{ toolbar: GridToolbar, footer: CustomFooterRow }}
            initialState={{
              columns: {
                columnVisibilityModel: {
                  transaction_id: false,
                  id: false,
                },
              },
            }}
          />
        </Box>
      </Itemb>
      <Modal
        open={modal_Open_no_all}
        onClose={closeam_all}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        {confirm_request_all ? (
          <Box sx={sec_style}>
            <>
              <div ref={printRef} style={{ display: "block", marginBottom: 5 }}>
                <Typography
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  variant="body2"
                  sx={{ textAlign: "center", mb: 2 }}
                >
                  ~The Cooperative~
                </Typography>

                <Typography
                  variant="h5"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  Commodity Storage
                </Typography>
                <Chip
                  sx={{ display: "flex", mt: 1, mb: 1 }}
                  label={confirm_request_all.Commodity}
                  variant="outlined"
                  color="success"
                />
                <Divider variant="middle" sx={{ mt: 1, mb: 1 }}>
                  <i>Member Details</i>
                </Divider>

                <div>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                  >
                    Date:{" "}
                    <b style={{ color: "black" }}>
                      {" "}
                      <FormatedDate value={date} />
                    </b>
                  </Typography>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                  >
                    Member: <b style={{ color: "black" }}>{name}</b>
                  </Typography>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                  >
                    Passbook: <b style={{ color: "black" }}>{passbook_id}</b>
                  </Typography>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                  >
                    Society: <b style={{ color: "black" }}>{society_name}</b>
                  </Typography>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                  >
                    Kind: <b style={{ color: "black" }}>{association_type}</b>
                  </Typography>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                  >
                    Savings Group:{" "}
                    <b style={{ color: "black" }}>{association_name}</b>
                  </Typography>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                  >
                    Warehouse:{" "}
                    <b style={{ color: "black" }}>{warehouse_name}</b>
                  </Typography>
                </div>

                <Divider variant="middle" sx={{ mt: 2, mb: 2 }}>
                  <i>Commodity Specification</i>
                </Divider>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div style={{ display: "block" }}>
                    <Typography
                      variant="h6"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      Grade: <b>{confirm_request_all.Grade}</b>{" "}
                    </Typography>
                    <Typography
                      variant="h6"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      Current {confirm_request_all.Commodity} price:{" "}
                      <b>
                        {currencyFormat.format(
                          confirm_request_all.Current_commodity_price
                        )}
                      </b>{" "}
                    </Typography>
                    <Typography
                      variant="h6"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      Number of Bags:{" "}
                      <b>{confirm_request_all.Amount_storing} </b>{" "}
                    </Typography>
                    <Typography
                      variant="h6"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      Units: <b>{confirm_request_all.Unit_kg}kg</b>{" "}
                    </Typography>
                    <Typography
                      variant="h6"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      Weight: <b>{confirm_request_all.Weight}kg </b>{" "}
                    </Typography>
                    <Typography
                      variant="h6"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      Tonnes: <b>{confirm_request_all.Tons}</b>{" "}
                    </Typography>
                    <Typography
                      variant="h6"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      Price per bag (Original):{" "}
                      <b>
                        {currencyFormat.format(
                          confirm_request_all.Price_per_bag
                        )}
                      </b>{" "}
                    </Typography>
                    <Typography
                      variant="h6"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      Price per bag (Charged):{" "}
                      <b>
                        {currencyFormat.format(
                          confirm_request_all.charged_price_per_bg
                        )}
                      </b>{" "}
                    </Typography>
                    <Typography
                      variant="h6"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      Current cash value:{" "}
                      <b>
                        {currencyFormat.format(
                          confirm_request_all.total_cash_value
                        )}
                      </b>{" "}
                    </Typography>
                  </div>
                  <div
                    style={{
                      display: "block",
                      marginLeft: "3px",
                      borderColor: "blue",
                    }}
                  >
                    {charges[0] ? (
                      <>
                        <Typography
                          variant="subtitle"
                          fontStyle="oblique"
                          fontFamily="Futura"
                        >
                          <b>
                            <u>Charges associated</u>
                          </b>
                        </Typography>
                        <Typography
                          variant="h6"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          Rebag (
                          {currencyFormat.format(charges[0].rebagging_fee)}):{" "}
                          <b>
                            {fees.rebagging_fee === true
                              ? "paid"
                              : "no rebaging"}
                          </b>{" "}
                        </Typography>
                        <Typography
                          variant="h6"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          Stack (
                          {currencyFormat.format(charges[0].stacking_fee)}):{" "}
                          <b>
                            {fees.stacking_fee === true
                              ? "paid"
                              : "no stacking"}
                          </b>{" "}
                        </Typography>
                        <Typography
                          variant="h6"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          Clean (
                          {currencyFormat.format(charges[0].cleaning_fee)}):{" "}
                          <b>
                            {fees.cleaning_fee === true
                              ? "paid"
                              : "no cleaning"}
                          </b>{" "}
                        </Typography>
                        <Typography
                          variant="h6"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          Destone (
                          {currencyFormat.format(charges[0].destoning_fee)}):{" "}
                          <b>
                            {fees.destone === true ? "paid" : "no destoning"}
                          </b>{" "}
                        </Typography>
                        <Typography
                          variant="h6"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          Store ({currencyFormat.format(charges[0].storage_fee)}
                          ):{" "}
                          <b>
                            {fees.storage_fee === true
                              ? "paid"
                              : "no storage_fee"}
                          </b>{" "}
                        </Typography>
                        <Typography
                          variant="h6"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          Stitch (
                          {currencyFormat.format(charges[0].stitching_fee)}):{" "}
                          <b>
                            {fees.stitching_fee === true
                              ? "paid"
                              : "no stitching"}
                          </b>{" "}
                        </Typography>
                        <Typography
                          variant="h6"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          Load ({currencyFormat.format(charges[0].loading_fee)}
                          ):{" "}
                          <b>
                            {fees.loading_fee === true ? "paid" : "no loading"}
                          </b>{" "}
                        </Typography>
                        <Typography
                          variant="h6"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          Empty Sack (
                          {currencyFormat.format(
                            charges[0].empty_sack_cost_fee
                          )}
                          ):{" "}
                          <b>
                            {fees.empty_sack_cost_fee === true
                              ? "paid"
                              : "no empty sack"}
                          </b>{" "}
                        </Typography>
                        <Typography
                          variant="h6"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          Tax ({currencyFormat.format(charges[0].tax_fee)}):{" "}
                          <b>paid</b>{" "}
                        </Typography>
                      </>
                    ) : (
                      <Box sx={{ width: "100%", justifyContent: "center" }}>
                        <CircularProgress size="15" />
                      </Box>
                    )}
                  </div>
                </div>
              </div>
              <Typography
                sx={{ mt: 2 }}
                variant="subtitle"
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              >
                Print:
              </Typography>
              <IconButton onClick={handlePrint}>
                <SummarizeIcon size="small" />
              </IconButton>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginLeft: 320,
                }}
              >
                <Button
                  variant="contained"
                  onClick={closeam_all}
                  color="error"
                  size="small"
                  sx={{ mr: 1 }}
                >
                  Cancel
                </Button>
              </div>
            </>
          </Box>
        ) : (
          <Box sx={{ width: "100%", justifyContent: "center" }}>
            <CircularProgress size="15" />
          </Box>
        )}
      </Modal>

      {/* retriva */}
      <Modal
        open={modal_Open_no_ret_all}
        onClose={handle_modal_Closee_ret_all}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        {confirm_request_all ? (
          <Box sx={sec_style}>
            <>
              <div
                ref={printRef_ret}
                style={{ display: "block", marginBottom: 5 }}
              >
                <Typography
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  variant="body2"
                  sx={{ textAlign: "center", mb: 2 }}
                >
                  ~The Cooperative~
                </Typography>

                <Typography
                  variant="h5"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  Commodity Retrieval
                </Typography>
                <Chip
                  sx={{ display: "flex", mt: 1, mb: 1 }}
                  label={confirm_request_all.Commodity}
                  variant="outlined"
                  color="success"
                />
                <Divider variant="middle" sx={{ mt: 1, mb: 1 }}>
                  <i>Member Details</i>
                </Divider>

                <div>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                  >
                    Date:{" "}
                    <b style={{ color: "black" }}>
                      {" "}
                      <FormatedDate value={date} />
                    </b>
                  </Typography>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                  >
                    Member: <b style={{ color: "black" }}>{name}</b>
                  </Typography>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                  >
                    Passbook: <b style={{ color: "black" }}>{passbook_id}</b>
                  </Typography>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                  >
                    Society: <b style={{ color: "black" }}>{society_name}</b>
                  </Typography>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                  >
                    Kind: <b style={{ color: "black" }}>{association_type}</b>
                  </Typography>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                  >
                    Savings Group:{" "}
                    <b style={{ color: "black" }}>{association_name}</b>
                  </Typography>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                  >
                    Warehouse:{" "}
                    <b style={{ color: "black" }}>{warehouse_name}</b>
                  </Typography>
                </div>

                <Divider variant="middle" sx={{ mt: 2, mb: 2 }}>
                  <i>Commodity Specification</i>
                </Divider>

                <Typography
                  variant="h6"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  Grade: <b>{confirm_request_all.Grade}</b>{" "}
                </Typography>
                <Typography
                  variant="h6"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  Current {confirm_request_all.Commodity} price:{" "}
                  <b>
                    {currencyFormat.format(
                      confirm_request_all.Current_commodity_price
                    )}
                  </b>{" "}
                </Typography>
                <Typography
                  variant="h6"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  Bags retrieving: <b>{confirm_request_all.Amount_storing} </b>{" "}
                </Typography>
                <Typography
                  variant="h6"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  Units: <b>{confirm_request_all.Unit_kg}kg</b>{" "}
                </Typography>
                <Typography
                  variant="h6"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  Weight: <b>{confirm_request_all.Weight}kg </b>{" "}
                </Typography>
                <Typography
                  variant="h6"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  Tonnes: <b>{confirm_request_all.Tons}</b>{" "}
                </Typography>
                <Typography
                  variant="h6"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  Price per bag (Charged):{" "}
                  <b>
                    {currencyFormat.format(confirm_request_all.Price_per_bag)}
                  </b>{" "}
                </Typography>
                <Typography
                  variant="h6"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  Value:{" "}
                  <b>
                    {currencyFormat.format(
                      confirm_request_all.total_cash_value
                    )}
                  </b>{" "}
                </Typography>
              </div>
              <Typography
                sx={{ mt: 2 }}
                variant="subtitle"
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              >
                Print:
              </Typography>
              <IconButton onClick={handlePrint_ret}>
                <SummarizeIcon size="small" />
              </IconButton>

              <Button
                variant="contained"
                onClick={handle_modal_Closee_ret_all}
                color="error"
                size="small"
                sx={{ mr: 1 }}
              >
                Cancel
              </Button>
            </>
          </Box>
        ) : (
          <Box sx={{ width: "100%", justifyContent: "center" }}>
            <CircularProgress size="15" />
          </Box>
        )}
      </Modal>
    </>
  );
};

const ItemCardy = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  margin: "15px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2), 0 4px 10px rgba(0, 0, 0, 0.2)",
  borderRadius: "15px",
}));

const Ittem = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  borderStyle: "groove",
  border: "3px",
  borderColor: "grey",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.2)",
  marginTop: "10px",
  minHeight: "50px",
  width: "100%",
  borderRadius: "10px",
}));

const PrettoSlider = styled(Slider)({
  color: '#52af77',
  height: 8,
  '& .MuiSlider-track': {
    border: 'none',
  },
  '& .MuiSlider-thumb': {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit',
    },
    '&::before': {
      display: 'none',
    },
  },
  '& .MuiSlider-valueLabel': {
    lineHeight: 1.2,
    fontSize: 12,
    background: 'unset',
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: '50% 50% 50% 0',
    backgroundColor: '#52af77',
    transformOrigin: 'bottom left',
    transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
    '&::before': { display: 'none' },
    '&.MuiSlider-valueLabelOpen': {
      transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
    },
    '& > *': {
      transform: 'rotate(45deg)',
    },
  },
});

const WareHouse = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { permissions } = useContext(AuthContext);
  const warehouse_id = location.state && location.state.id;
  const warehouse_name = location.state && location.state.name;
  const society_name = location.state && location.state.society;
  const society_id = location.state && location.state.society_id;
  const cash_worth = location.state && location.state.cash_worth;
  const [warehouseBasics, setWarehouseBasics] = useState([]);
  const [aggregator, setAggregator] = useState();
  const [open_modal, setOpen_modal] = useState(false);
  const [warehouseCommodities, setWarehouseCommodities] = useState([]);
  const [all_members_details, setAll_members_details] = useState([]);
  const [all_associations, setAll_associations] = useState([]);
  const [openCommodities, setOpenCommodities] = useState(false);
  const [soc_com, setSoc_com] = useState([]);
  const [openn, setOpenn] = React.useState(false);
  const [bie, setBie] = useState(false);
  const [allMembers, setAllMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [exist, setExist] = useState({
    commodity_id: warehouse_id,
    association_member_id: null,
    member_id: null,
  });
  const [acts_all, setActs_all] = useState([]);
  const [total_cash_value, setTotal_cash_value] = useState();
  const [total_bags, setTotal_bags] = useState();
  const [total_balance, setTotal_balance] = useState();
  const [start_date_all, setStart_date_all] = useState("");
  const [end_date_all, setEnd_date_all] = useState("");
  const [mini_loading, setMini_loading] = useState(false);
  const [charges, setCharges] = useState([]);
  const [confirm_request_all, setConfirm_request_all] = useState([]);
  const [processingComplete_all, setProcessingComplete_all] = useState(false);
  const [fees, setFees] = useState([]);
  const [modal_Open_no_all, setModal_open_no_all] = useState(false);
  const [modal_Open_no_ret_all, setModal_open_no_ret_all] = useState(false);
  const [aggre_mode, setAggre_mode] = useState(false);
  const [chats, setChats] = useState([]);
  const [open_chat, setOpen_Chat] = useState();
  const [chat_area, setChat_area] = useState();
  const [modal_chat, setModal_chat] = useState(false);
  const [loan_data_ini, setLoan_data_ini] = useState();
  const [loan_field, setLoan_field] = useState(false);
  const [loans_orders, setLoans_orders] = useState([]);
  const [opennn, setOpennn] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [interest_per, setInterest_per] = useState(null);
  // const [processing_per, setProcessing_per] = useState(null);
  // const [application_per, setApplication_per] = useState(null);
  const [house, setHouse] = useState([]);
  const [pay_modal, setPay_modal] = useState(false);
  const [release_modal, setRelease_modal] = useState(false);
  const [rel_date, setRel_date] = useState(dayjs());
  const [pay_data, setPay_data] = useState(false);
  const [savin_id, setSavin_id] = useState(null);
  const [amount_re, setAmount_re] = useState(null);
  const [amount_rel, setAmount_rel] = useState(null);
  const [narration_rel, setNarration_rel] = useState(null);
  const [date_rel, setDate_rel] = useState(dayjs());
  const [max, setMax] = useState(false);
  const [hold_act_id, setHold_act_id] = useState(null);
  const [ongoing_deals, setOngoing_deals] = useState([])
  const [closed_deals, setClosed_deals] = useState([])
  const [one_deal, setOne_deal] = useState({})
  const [deal_elegible, setDeal_elegible] = useState([])
  const [me_active, setMe_active] = useState(null)
  const [one_elegibility, setOne_elegibility] = useState(0)
  const [one_savings, setOne_savings] = useState([])
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [open_modal_print, setOpen_modal_print] = useState(false);

  const style_print = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    maxHeight: "95vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "7px",
      height: "7px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
    bgcolor: "background.paper",
    border: "1px solid #e7ecef",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  const printReceipt = () => {
    setOpen_modal_print(true);
  };

  const closeModalReceipt = () => {
    setOpen_modal_print(false);
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const printRefer = React.useRef();

  const handlePrinter = async () => {
    const element = printRefer.current;
    const canvas = await html2canvas(element);
    const data = canvas.toDataURL("image/png");

    const pdf = new jsPDF();
    const imgProperties = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;

    const marginLeft = 25;
    const marginTop = 25;
    const marginRight = 25;
    const marginBottom = 25;

    pdf.addImage(
      data,
      "PNG",
      marginLeft,
      marginTop,
      pdfWidth - marginLeft - marginRight,
      pdfHeight - marginTop - marginBottom
    );

    pdf.save("TradeInvoice.pdf");
  };


  useEffect(() => {
    if(me_active){
      api
      .get(`/commodity/get/savings/accounts/one/member/${me_active}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setOne_savings(response.data?.accounts);
      })
      .catch(function (error) {
        console.log(error);
      });
    }
    
  },[me_active])

  const payForCommodity = (savings_acc_id) => {
    if(house?.house_details?.current_balance >= one_elegibility * (one_deal?.price / one_deal?.bags)){
      const data = new FormData()
      data.append('transaction_id', me_active)
      data.append('amount_retrieving', one_elegibility)
      data.append('cash_value', one_elegibility * (one_deal?.price / one_deal?.bags))
      data.append('savings_account_id', savings_acc_id)
      data.append('trade_id', one_deal.trade_id)
      data.append('warehouse_id', warehouse_id)

      toast.promise(
        api.post('/societywarehouse/add/commodities/mobilized', data ,{
          headers: {
            Authorization: 'Bearer ' + fetchToken()
          }
        }),
        {
          loading: 'Mobilizing...',
          success: (response) => {
            const dato = one_deal
            handleCloseUserMenu()
            call_vendors_deals();
            mobilize(dato)
            setOne_elegibility(0);
            setOne_deal(dato);
            fetch_activities_all(one_deal?.commodity_id, one_deal?.grade, one_deal?.unit);
            
            return response.data
          },
          error: (error) => {
            console.log(error)
            return "An Error Occurred. Please try again"
          }
        }
      )
    } else {
      toast.error("Insufficient funds")
    }
  }

  const satisfied_action = (decision) => {
    if(decision === 'pick_up'){
      toast.promise(
        api.get(`/societywarehouse/pick/up/at/local/warehouse/${one_deal?.trade_id}`,{
          headers: {
            Authorization: 'Bearer ' + fetchToken()
          }
        }),
        {
          loading: 'Finishing Up...',
          success: (response) => {
            const dato = one_deal
            call_vendors_deals();
            mobilize(dato)
            setOne_elegibility(0);
            setOne_deal(dato);
            fetch_activities_all(one_deal?.commodity_id, one_deal?.grade, one_deal?.unit);
            
            return response.data
          },
          error: (error) => {
            console.log(error)
            return "An Error Occurred. Please try again"
          }
        }
      )
    }else {
      const data = new FormData()
      data.append('society_id', society_id)
      data.append('grade', one_deal?.grade)
      data.append('unit', one_deal?.unit)
      data.append('bags', one_deal?.bags)
      data.append('trade_id', one_deal?.trade_id)

      toast.promise(
        api.post('/societywarehouse/transfer/trade/bags/to/main/warehouse', data, {
          headers: {
            Authorization: 'Bearer ' + fetchToken()
          }
        }),
        {
          loading: 'Moving Bags...',
          success: (response) => {
            const dato = one_deal
            call_vendors_deals();
            setOne_elegibility(0);
            mobilize(dato)
            setOne_deal(dato);
            fetch_activities_all(one_deal?.commodity_id, one_deal?.grade, one_deal?.unit);
            
            return response.data
          },
          error: (error) => {
            console.log(error)
            return "An Error Occurred. Please try again"
          }
        }
      )
    }
  }

  const fetch_activities_all = (commodity_id, grade, unit) => {
    const info = new FormData();
    info.append("warehouse_id", warehouse_id);
    info.append("commodity_id", commodity_id);
    info.append("start_date", '');
    info.append("end_date", '');
    info.append("grade", grade);
    info.append("unit", unit);

    api
      .post("/commodity/commodity/activities/commodity/yeah", info, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setDeal_elegible(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const call_vendors_deals = () => {
    api
      .get(`/societywarehouse/get/vendors/deals/warehouse/${warehouse_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setOngoing_deals(response.data?.ongoing_trade_data);
        setClosed_deals(response.data?.closed_trade_data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  useEffect(() => {
    call_vendors_deals();
  },[])

  const mobilize = (item) => {
    if(item.trade_id === one_deal.trade_id){
      setOne_deal({});
    } else {
      setOne_deal(item);
      fetch_activities_all(item.commodity_id, item.grade, item.unit);
    }
  }

  const handleCloseModal = () => {
    setOpen_modal(false);
    setAmount_rel(null);
    setNarration_rel(null);
    setDate_rel(dayjs());
  };

  const handleReleaseFinallyCash = () => {
    const data = new FormData();
    data.append("date", date_rel);
    data.append("amount", amount_rel);
    data.append("narration", narration_rel);
    data.append("society_id", society_id);
    data.append("local_ware_id", house?.house_details?.id);
    api
      .post("/societywarehouse/release/cash/main/account", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response.data);
        handleCloseModal();
        getHouseDetails();
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  function formatDateToYearMonthDayTime(date) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    let suffix = "th";

    if (day === 1 || day === 21 || day === 31) {
      suffix = "st";
    } else if (day === 2 || day === 22) {
      suffix = "nd";
    } else if (day === 3 || day === 23) {
      suffix = "rd";
    }

    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const minutesStr = minutes < 10 ? "0" + minutes : minutes;

    return `${day}${suffix} ${month} ${year}, ${hours}:${minutesStr} ${ampm}`;
  }

  const style_rel = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    maxHeight: "80vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "7px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
    bgcolor: "background.paper",
    border: "1px solid #e7ecef",
    borderRadius: "13px",
    boxShadow: 24,
    p: 4,
  };

  const handleReleaseFinally = () => {
    const newar = new FormData();
    newar.append("act_id", hold_act_id);
    newar.append("local_warehouse_id", house?.house_details?.id);
    newar.append("date", rel_date);
    newar.append("society_id", society_id);

    api
      .post("/societywarehouse/release/crops/main/warehouse/confirmed", newar, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response.data);
        closeReleaseModal();
        getHouseDetails();
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const visitAccount = () => {
    navigate("/accounts/society", {
      state: { society_id: society_id, name: society_name },
    });
  };

  const closePayModal = () => {
    setPay_modal(false);
    setSavin_id(null);
    setAmount_re(null);
    setMax(false);
    setPay_data([]);
  };
  const closeReleaseModal = () => {
    setRelease_modal(false);
    setRel_date(dayjs());
    setHold_act_id(null);
  };

  const actionDem = (act_id, balance) => {
    if (balance > 0) {
      api
        .get(`/societywarehouse/create/pay/balance/${act_id}`, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          setPay_data(response.data);
          setPay_modal(true);
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      setRelease_modal(true);
      setHold_act_id(act_id);
    }
  };

  const handleSettleFinally = () => {
    const data = new FormData();
    data.append("act_id", pay_data?.act?.id);
    data.append("savin_id", savin_id);
    data.append("amount_re", amount_re);
    data.append("max", max);
    data.append("local_warehouse_id", house?.house_details?.id);

    api
      .post("/societywarehouse/create/pay/balance/confirmed", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response.data);
        getHouseDetails();
        closePayModal();
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const doMax = () => {
    setMax((prev) => !prev);
    setAmount_re(parseFloat(pay_data?.act?.balance));
  };

  const handleOpenModal = (trs) => {
    setOpen_modal(true);
  };

  const styler = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "480px",
    maxHeight: "550vh",
    overflowY: "auto",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "7px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
    bgcolor: "background.paper",
    border: "1px solid #e7ecef",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  function formatDateToYearMonthDay(date) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    let suffix = "th";

    if (day === 1 || day === 21 || day === 31) {
      suffix = "st";
    } else if (day === 2 || day === 22) {
      suffix = "nd";
    } else if (day === 3 || day === 23) {
      suffix = "rd";
    }

    return `${day}${suffix} ${month} ${year}`;
  }

  const activateHouse = () => {
    api
      .get(
        `/societywarehouse/get/society/warehouse/account/create/${warehouse_id}`,
        {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        }
      )
      .then(function (response) {
        toast.success(response.data);
        getHouseDetails();
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getHouseDetails = () => {
    api
      .get(`/societywarehouse/get/society/warehouse/account/${warehouse_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
        
      })
      .then(function (response) {
        setHouse(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const get_orders = () => {
    api
      .get(`/association/loans/info/warehouse/${warehouse_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setLoans_orders(response.data?.loan);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    get_orders();
    getHouseDetails();
  }, [warehouse_id]);

  useEffect(() => {
    get_orders();
    // const intervalId = setInterval(get_orders, 2000);
    // return () => clearInterval(intervalId);
  }, []);

  const fetchLoanFuo = () => {
    api
      .get(`/account/get/warehouse/loans/info/${warehouse_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setLoan_data_ini(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const formik = useFormik({
    initialValues: {
      interest_per: null,
      processing_per: null,
      application_per: null,
    },
    validationSchema: Yup.object({
      interest_per: Yup.number().required("Can not be empty"),
      processing_per: Yup.number().required("Can not be empty"),
      application_per: Yup.number().required("Can not be empty"),
    }),
    onSubmit: (values) => {
      setLoading(true);
      const data = new FormData();
      data.append("warehouse_id", warehouse_id);
      data.append("interest_per", values.interest_per);
      data.append("processing_per", values.processing_per);
      data.append("application_per", values.application_per);

      api
        .post("/account/activate/account", data, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          toast.success(response.data);
          formik.handleReset();
          setLoan_field(false);
          fetchLoanFuo();
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          setLoading(false);
        });
    },
  });

  const fetch_chats = () => {
    api
      .get(`/account/nego/for/warehouse/${warehouse_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setChats(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    fetch_chats();
    // const intervalId = setInterval(fetch_chats, 2000);
    // return () => clearInterval(intervalId);
  }, []);

  const pic = (pic) => {
    const de = decode(pic);
    return `data:image/jpeg;base64,${btoa(de)}`;
  };

  const openMessages = (
    nego_id,
    username,
    userimage,
    user_phone,
    agreed_price,
    agree,
    nego_status,
    order_id
  ) => {
    setChat_area(
      <MessageArea
        nego_id={nego_id}
        setChat_area={setChat_area}
        fetch_chats={fetch_chats}
        username={username}
        userimage={userimage}
        user_phone={user_phone}
        agreed_price={agreed_price}
        agree={agree}
        nego_status={nego_status}
        order_id={order_id}
      />
    );

    setModal_chat(true);
  };

  useEffect(() => {
    api
      .get(`/account/commodities/charges/${warehouse_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setCharges(response.data);
      });
  }, []);

  const fetch_all_activities = () => {
    const info = new FormData();
    info.append("warehouse_id", warehouse_id);
    info.append("start_date", start_date_all);
    info.append("end_date", end_date_all);

    api
      .post("/commodity/warehouse/activities/commodity", info, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setActs_all(response.data?.activities);
        setTotal_cash_value(response.data?.total_cash_value);
        setTotal_bags(response.data?.total_bags);
        setTotal_balance(response.data?.total_balance);
      });
  };
  const clear_filter_all = () => {
    setStart_date_all("");
    setEnd_date_all("");
    fetch_all_activities();
  };

  useEffect(() => {
    fetch_all_activities();
  }, []);

  const visitMemberAgg = ({ params }) => {
    navigate("/onemember/", {
      state: {
        Member_id: params.row.member_id,
        Fullname: `${params.row.firstname} ${params.row.lastname}`,
      },
    });
  };

  const columns_all = [
    {
      field: "goto",
      headerName: "Visit",
      type: "actions",
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
          icon={<PersonIcon />}
          onClick={() => visitMemberAgg({ params })}
          label="View"
        />,
      ],
    },
    {
      field: "id",
      headerName: "Id",
      flex: 1,
    },

    {
      field: "member_id",
      headerName: "Member id",
      flex: 1,
    },
    {
      field: "account_id",
      headerName: "Account Id",
      flex: 1,
    },
    {
      field: "transaction_id",
      headerName: "Id",
      flex: 1,
    },
    {
      field: "firstname",
      headerName: "firstname",
      flex: 1,
    },
    {
      field: "lastname",
      headerName: "lastname",
      flex: 1,
    },
    {
      field: "fullname",
      headerName: "Member",
      flex: 1,
      renderCell: (params) => (
        <div>
          {params.row.firstname} {params.row.lastname}
        </div>
      ),
    },
    {
      field: "passbook_id",
      headerName: "Passbook",
      flex: 1,
    },
    {
      field: "transaction_date",
      headerName: "DateTime",
      flex: 1,
      renderCell: (params) => (
        <FormatedDate value={params.row.transaction_date} />
      ),
    },
    {
      field: "commodity",
      headerName: "Commodity",
      flex: 1,
    },
    {
      field: "transaction_type_id",
      headerName: "Act",
      flex: 1,
      renderCell: (params) =>
        params.row.transaction_type_id === 1 ? "Store" : "Retrieve",
    },
    {
      field: "amount_of_commodity",
      headerName: "Bags",
      flex: 1,
    },
    {
      field: "retriv_bags",
      headerName: "Bags left",
      flex: 1,
    },
    {
      field: "cash_value",
      headerName: "Cash value(GHS)",
      flex: 1,
      renderCell: (params) => currencyFormat.format(params.row.cash_value),
    },
    {
      field: "grade",
      headerName: "Grade",
      flex: 1,
    },
    {
      field: "unit_per_kg",
      headerName: "Units(kg)",
      flex: 1,
    },
    {
      field: "username",
      headerName: "Prepared by",
      flex: 1,
    },
    {
      field: "association_name",
      headerName: "Savings Group",
      flex: 1,
    },
    {
      field: "association_type",
      headerName: "Savings Group Kind",
      flex: 1,
    },
    {
      field: "total_cash_balance",
      headerName: "Cash Balance",
      flex: 1,
      renderCell: (params) =>
        currencyFormat.format(params.row.total_cash_balance),
    },
    {
      field: "view",
      type: "actions",
      width: 20,
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
          icon={<SummarizeIcon />}
          onClick={() => handle_print_all({ params })}
          label="View"
        />,
      ],
    },
    // {
    //   field: "delete",
    //   type: "actions",
    //   width: 20,
    //   getActions: (params: GridRowParams) => [
    //     <GridActionsCellItem
    //       icon={<DeleteIcon />}
    //       onClick={() => handleClickOpen(params.row.transaction_id)}
    //       label="Open"
    //     />,
    //   ],
    // },
  ];

  const [date, setDate] = useState();

  const handle_print_all = async ({ params }) => {
    setMini_loading(true);
    setDate(params.row.transaction_date);
    await proccess_info_all({ params });
  };

  const [member_fullname, setMember_fullname] = useState("");
  const [member_passbook_id, setMember_passbook_id] = useState("");
  const [member_association_type, setMember_association_type] = useState("");
  const [member_association_name, setMember_association_name] = useState("");

  const proccess_info_all = ({ params }) => {
    setMember_fullname(
      <div>
        {params.row.firstname} {params.row.lastname}
      </div>
    );
    setMember_passbook_id(params.row.passbook_id);
    setMember_association_type(params.row.association_type);
    setMember_association_name(params.row.association_name);

    api
      .get(`/account/act/details/edit/${params.row.transaction_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setFees(response.data?.details);
        const data = new FormData();
        data.append("commodity_id", params.row.id);
        data.append("grade_id", response.data?.details.grade_id);
        data.append("unit_id", response.data?.details.units_id);
        data.append(
          "amount_storing",
          response.data?.details.amount_of_commodity
        );
        data.append("member_com_acc", params.row.account_id);
        data.append("rebag", response.data?.details.rebagging_fee);
        data.append("stack", response.data?.details.stacking_fee);
        data.append("clean", response.data?.details.cleaning_fee);
        data.append("destone", response.data?.details.destoning_fee);
        data.append("store", response.data?.details.storage_fee);
        data.append("stitch", response.data?.details.stitching_fee);
        data.append("load", response.data?.details.loading_fee);
        data.append("empty_sack", response.data?.details.empty_sack_cost_fee);
        api
          .post("/account/process/storage", data, {
            headers: {
              Authorization: "Bearer " + fetchToken(),
            },
          })
          .then(function (response) {
            setConfirm_request_all(response.data);
            setProcessingComplete_all(true);
            if (params.row.transaction_type_id === 2) {
              setModal_open_no_ret_all(true);
            } else {
              setModal_open_no_all(true);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const CustomFooterRow = () => {
    return (
      <div>
        <div style={{ display: "flex", padding: "4px" }}>
          <Typography variant="h6" sx={{ mr: 4 }}>
            <b>Total:</b>
          </Typography>
          <Typography variant="h6" sx={{ mr: 4 }}>
            <b>Cash Value: {currencyFormat.format(total_cash_value)}</b>{" "}
          </Typography>
          <Typography variant="h6" sx={{ mr: 4 }}>
            <b>Bags: {total_bags}</b>{" "}
          </Typography>
          <Typography variant="h6" sx={{ mr: 4 }}>
            <b>Cash Balance: {currencyFormat.format(total_balance)}</b>{" "}
          </Typography>
        </div>
      </div>
    );
  };

  const closeam_all = () => {
    setMini_loading(false);
    setModal_open_no_all(false);
  };

  const handle_modal_Closee_ret_all = () => {
    setModal_open_no_ret_all(false);
  };

  const printRef = React.useRef();
  const printRef_ret = React.useRef();

  const handlePrint = async () => {
    const element = printRef.current;
    const canvas = await html2canvas(element);
    const data = canvas.toDataURL("image/png");

    const pdf = new jsPDF();
    const imgProperties = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;

    const marginLeft = 25;
    const marginTop = 25;
    const marginRight = 25;
    const marginBottom = 25;

    pdf.addImage(
      data,
      "PNG",
      marginLeft,
      marginTop,
      pdfWidth - marginLeft - marginRight,
      pdfHeight - marginTop - marginBottom
    );

    pdf.save("CommodityStorage.pdf");
    setMini_loading(false);
    setModal_open_no_all(false);
  };

  const handlePrint_ret = async () => {
    const element = printRef_ret.current;
    const canvas = await html2canvas(element);
    const data = canvas.toDataURL("image/png");

    const pdf = new jsPDF();
    const imgProperties = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;

    const marginLeft = 25;
    const marginTop = 25;
    const marginRight = 25;
    const marginBottom = 25;

    pdf.addImage(
      data,
      "PNG",
      marginLeft,
      marginTop,
      pdfWidth - marginLeft - marginRight,
      pdfHeight - marginTop - marginBottom
    );

    pdf.save("CommodityRetrieval.pdf");
    setMini_loading(false);
    setModal_open_no_ret_all(false);
  };

  const sec_style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 620,
    maxHeight: "80vh",
    overflowY: "auto",
    bgcolor: "background.paper",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  const aggre_style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 520,
    maxHeight: "80vh",
    overflowY: "auto",
    bgcolor: "background.paper",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  const chats_style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 850,
    maxHeight: "150vh",
    overflowY: "auto",
    bgcolor: "background.paper",
    borderRadius: "10px",
    boxShadow: 24,
    p: 4,
  };

  const handleCloss = () => {
    setOpenn(false);
  };
  const handleOpen = () => {
    setOpenn(true);
  };

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  const fetch_soc_com = () => {
    const hh = new FormData();
    hh.append("society_id", society_id);
    hh.append("com_acc_id", warehouse_id);

    api
      .post("/account/commodities/joiner", hh, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setSoc_com(response.data?.All_Commodities);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const [number_of_members, setnumber_of_members] = useState(null);
  const fetchInfo = () => {
    api
      .get(`/account/commodity/account/info/${warehouse_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setWarehouseBasics(response.data?.Basic_Info);
        setAggregator(response.data?.aggregator);
        setWarehouseCommodities(response.data?.Related_Commodities);
        setAll_members_details(response.data?.all_members);
        setAll_associations(response.data?.associations);
        setnumber_of_members(response.data?.all_bags);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchInfo();
    fetch_soc_com();
  }, []);

  const [new_list, setNew_list] = useState();

  const handle_new_commodity = () => {
    setNew_list(
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {soc_com.map((item) => (
          <Chip
            key={item.id}
            label={item.commodity}
            size="small"
            icon={<AddCircleIcon size="small" />}
            onClick={() => addition_confirmed(item.id)}
            color="secondary"
            style={{ margin: "4px" }}
          />
        ))}
      </div>
    );
  };
  const [open, setOpen] = useState(false);

  const [commoditiesData, setCommoditiesData] = useState({
    warehouse_id: warehouse_id,
    warehouse: warehouse_name,
    community: warehouseBasics.community,
    rebagging_fee: warehouseBasics.rebagging_fee,
    stacking_fee: warehouseBasics.stacking_fee,
    destoning_fee: warehouseBasics.destoning_fee,
    cleaning_fee: warehouseBasics.cleaning_fee,
    storage_fee: warehouseBasics.storage_fee,
    tax_fee: warehouseBasics.tax_fee,
    stitching_fee: warehouseBasics.stitching_fee,
    loading_fee: warehouseBasics.loading_fee,
    empty_sack_cost_fee: warehouseBasics.empty_sack_cost_fee,
  });

  const handleClose = () => {
    setOpen(false);
    setCommoditiesData({
      warehouse_id: warehouse_id,
      warehouse: warehouse_name,
      community: warehouseBasics.community,
      rebagging_fee: warehouseBasics.rebagging_fee,
      stacking_fee: warehouseBasics.stacking_fee,
      destoning_fee: warehouseBasics.destoning_fee,
      cleaning_fee: warehouseBasics.cleaning_fee,
      storage_fee: warehouseBasics.storage_fee,
      tax_fee: warehouseBasics.tax_fee,
      stitching_fee: warehouseBasics.stitching_fee,
      loading_fee: warehouseBasics.loading_fee,
      empty_sack_cost_fee: warehouseBasics.empty_sack_cost_fee,
    });
  };

  useEffect(() => {
    setCommoditiesData({
      warehouse_id: warehouse_id,
      warehouse: warehouse_name,
      community: warehouseBasics.community,
      rebagging_fee: warehouseBasics.rebagging_fee,
      stacking_fee: warehouseBasics.stacking_fee,
      destoning_fee: warehouseBasics.destoning_fee,
      cleaning_fee: warehouseBasics.cleaning_fee,
      storage_fee: warehouseBasics.storage_fee,
      tax_fee: warehouseBasics.tax_fee,
      stitching_fee: warehouseBasics.stitching_fee,
      loading_fee: warehouseBasics.loading_fee,
      empty_sack_cost_fee: warehouseBasics.empty_sack_cost_fee,
    });
  }, [open]);

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;

    if (type === "checkbox") {
      setCommoditiesData({
        ...commoditiesData,
        [name]: checked,
      });
    } else {
      setCommoditiesData({
        ...commoditiesData,
        [name]: value,
      });
    }
  };

  const createCommodities = (event) => {
    event.preventDefault();
    handleOpen();
    api
      .post("/account/commodity/edit/charges", commoditiesData, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response.data);
        setCommoditiesData({
          warehouse_id: warehouse_id,
          warehouse: warehouse_name,
          community: warehouseBasics.community,
          rebagging_fee: warehouseBasics.rebagging_fee,
          stacking_fee: warehouseBasics.stacking_fee,
          destoning_fee: warehouseBasics.destoning_fee,
          cleaning_fee: warehouseBasics.cleaning_fee,
          storage_fee: warehouseBasics.storage_fee,
          tax_fee: warehouseBasics.tax_fee,
          stitching_fee: warehouseBasics.stitching_fee,
          loading_fee: warehouseBasics.loading_fee,
          empty_sack_cost_fee: warehouseBasics.empty_sack_cost_fee,
        });
        setOpen(false);
        fetch_soc_com();
        fetchInfo();
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        handleCloss();
      });
  };

  const addition_confirmed = (commodity_id) => {
    handleOpen();
    const ff = new FormData();
    ff.append("warehouse_id", warehouse_id);
    ff.append("commodity_id", commodity_id);

    api
      .post("/account/finally/add_com", ff, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response.data);
        fetchInfo();
        fetch_soc_com();
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        handleCloss();
      });
  };

  // console.log(warehouseBasics)

  

  const handleCommodityInfo = (commodity_id, commodity) => {
    setOpenCommodities(
      <CommodityInside
        society_name={society_name}
        warehouse_name={warehouse_name}
        warehouse_id={warehouse_id}
        commodity={commodity}
        commodity_id={commodity_id}
      />
    );
  };

  const [open_members, setOpen_members] = useState();
  const [open_members_srch, setOpen_members_srch] = useState(false);

  const handleOpenMembers = () => {
    setOpen_members_srch(true);
    setOpen_members(
      all_members_details &&
        all_members_details.map((item) => (
          <div style={{ display: "flex", m: 1 }}>
            <Tooltip
              title={item.commodities.map((commodity) => (
                <div style={{ display: "block" }}>
                  <Chip
                    key={commodity.commodity_id}
                    label={
                      <b>
                        <i>{commodity.commodity}</i>
                      </b>
                    }
                    size="small"
                    variant="outlined"
                    sx={{ color: "#000", m: 1 }}
                  />
                </div>
              ))}
              followCursor
              leaveDelay={100}
              placement="top"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  margin: 4,
                  padding: 4,
                }}
              >
                <Avatar
                  alt={item.name}
                  src={pic(item.image)}
                  sx={{ width: 56, height: 56 }}
                />
                <Typography
                  sx={{ color: "#540b0e" }}
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  <b style={{ color: "black" }}>{item.name}</b>
                </Typography>

                <Typography
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  sx={{ color: "#780000" }}
                >
                  See Activities
                </Typography>
                <IconButton
                  onClick={() =>
                    handleClickViewMember(
                      item.name,
                      item.image,
                      item.member_id,
                      item.commodities,
                      item.passbook_id,
                      item.association_name,
                      item.cash_value,
                      item.account_id,
                      item.association_id,
                      item.association_type
                    )
                  }
                >
                  <LaunchIcon />
                </IconButton>
              </div>
            </Tooltip>
            <Divider variant="middle" orientation="vertical" flexItem />
          </div>
        ))
    );
  };

  const [search_member, setSearch_member] = useState("");

  useEffect(() => {
    const gh = new FormData();
    gh.append("account_id", warehouse_id);
    gh.append("search_member", search_member);

    api
      .post("/account/search/specific/member/ok", gh, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setAll_members_details(response.data?.all_members);
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        if (search_member) {
          handleOpenMembers();
        }
      });
  }, [search_member]);

  const fetchInfoo = () => {
    api
      .get(`/account/commodity/account/info/${warehouse_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setWarehouseBasics(response.data?.Basic_Info);
        setAggregator(response.data?.aggregator);
        setWarehouseCommodities(response.data?.Related_Commodities);
        setAll_members_details(response.data?.all_members);
        setAll_associations(response.data?.associations);
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        handleOpenMembers();
      });
  };

  // join member
  const fetchAllMembersyes = () => {
    api
      .get(`/commodity/everymember/join/${warehouse_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setAllMembers(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchAllMembersyes();
  }, []);

  const handleClickBie = () => {
    fetchAllMembersyes();
    setBie(true);
  };

  const handleTum = () => {
    setBie(false);
  };

  const registerExistingMember = (event) => {
    event.preventDefault();
    handleOpen();
    api
      .post("/account/membercommodities", exist, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response.data);
        handleTum();
      })
      .catch(function (error) {
        console.log(error);
        handleCloss();
      })
      .finally(function () {
        fetchInfo();
        handleCloss();
      });
  };

  const handleClickViewMember = (
    name,
    image,
    member_id,
    commodities,
    passbook_id,
    association_name,
    cash_value,
    account_id,
    association_id,
    association_type
  ) => {
    setOpenCommodities(
      <MemberInside
        warehouse_name={warehouse_name}
        warehouse_id={warehouse_id}
        name={name}
        image={image}
        member_id={member_id}
        commodities={commodities}
        passbook_id={passbook_id}
        association_name={association_name}
        cash_value={cash_value}
        account_id={account_id}
        association_id={association_id}
        association_type={association_type}
        society_name={society_name}
      />
    );
  };

  const visitAssociations = (association_id) => {
    api
      .get(`/association/${association_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        navigate("/association/", { state: { responseData: response.data } });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const [order, setOrder] = useState([]);
  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const fetch_all_orders = () => {
    api
      .get("/account/get/all/orders", {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setOrder(response.data?.all_orders);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  useEffect(() => {
    fetch_all_orders();
    // const intervalId = setInterval(fetch_all_orders, 5000);
    // return () => clearInterval(intervalId);
  }, []);

  const orders = (anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 400 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <Typography
        variant="h5"
        fontStyle="normal"
        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
        textAlign="center"
      >
        <b>All Orders</b>
      </Typography>
      <Box>
        {order &&
          order.map((item) => {
            if (item.order_type === "Buy") {
              return item ? (
                <Box sx={{ display: "flex" }}>
                  <Item_order_buy>
                    <Typography
                      color="#fff"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      variant="h6"
                      sx={{ mr: 3, ml: 1 }}
                    >
                      <b>{item.commodity}</b>
                    </Typography>

                    <Typography
                      color="#fff"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      variant="h6"
                      sx={{ mr: 3 }}
                    >
                      <b>{item.bags}bags</b>
                    </Typography>

                    <Typography
                      color="#fff"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      variant="h6"
                      sx={{ mr: 7 }}
                    >
                      <b>{item.grade}</b>
                    </Typography>
                  </Item_order_buy>
                  <DetailsModal item={item} />
                </Box>
              ) : (
                <Box>
                  <CircularProgress size={45} />
                </Box>
              );
            } else {
              return item ? (
                <Box sx={{ display: "flex" }}>
                  <Item_order_sell>
                    <Typography
                      color="#fff"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      variant="h6"
                      sx={{ mr: 3, ml: 1 }}
                    >
                      <b>{item.commodity}</b>
                    </Typography>

                    <Typography
                      color="#fff"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      variant="h6"
                      sx={{ mr: 3 }}
                    >
                      <b>{item.bags}bags</b>
                    </Typography>

                    <Typography
                      color="#fff"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      variant="h6"
                      sx={{ mr: 7 }}
                    >
                      <b>{item.grade}</b>
                    </Typography>
                  </Item_order_sell>
                  <DetailsModal item={item} />
                </Box>
              ) : (
                <Box>
                  <CircularProgress size={45} />
                </Box>
              );
            }
          })}
      </Box>
    </Box>
  );

  const [all_aggregator, setAll_aggregator] = useState([]);
  const openSetAggregator = () => {
    api
      .get("/account/all/aggregators", {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setAll_aggregator(response.data?.aggregators);
        setAggre_mode(true);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleNewAggre = (user_id) => {
    const data = new FormData();
    data.append("warehouse_id", warehouse_id);
    data.append("user_id", user_id);
    api
      .post("/account/set/aggregator", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response.data);
        fetchInfo();
        setAggre_mode(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchLoanFuo();
  }, []);

  const setupLoan = () => {
    setLoan_field(true);
  };

  const handleReciept = (id) => {
    if (permissions && permissions.download_loan_advise === true) {
      api
        .get(`/transactions/loan/advise/commodity/${id}`, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          setOpennn(
            <LoanAdviseCommodity
              Loan_Details={response.data?.Loan_Details}
              More_Details={response.data?.More_Details}
              Transaction_Details={response.data?.Transaction_Details}
              Repayment_Schedule={response.data?.Repayment_Schedule}
              Amount_Total={response.data?.Amount_Total}
              Interest_Total={response.data?.Interest_Total}
              Total_Khraa={response.data?.Total_Khraa}
            />
          );
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      toast.warning("Not Authorized");
    }
  };

  return (
    <div className="app">
      <main className="content">
        <Box sx={{ m: 5 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Header title="Warehouse" />
          </Box>
          <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
              <Typography
                sx={{ textAlign: "center" }}
                variant="h3"
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              >
                <b>
                  {warehouse_name.includes("Warehouse" || "warehouse")
                    ? warehouse_name
                    : `${warehouse_name} Warehouse`}
                </b>
              </Typography>

              <SwipeableDrawer
                anchor="left"
                open={state["left"]}
                onClose={toggleDrawer("left", false)}
                onOpen={toggleDrawer("left", true)}
              >
                {orders("left")}
              </SwipeableDrawer>
            </Grid>

            <Grid item xs={12} md={12}>
              <Accordion
                sx={{
                  mb: 1,
                  borderRadius: 7,
                  boxShadow:
                    "0 4px 8px rgba(0, 0, 0, 0.2), 0 4px 10px rgba(0, 0, 0, 0.2)",
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                    <b>Account</b>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={2}>
                    {house && house?.exist === false ? (
                      <Grid item xs={12} md={12}>
                        <Chip
                          size="small"
                          label={
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Activate Account</b>
                            </Typography>
                          }
                          sx={{
                            borderRadius: 2,
                            m: "auto",
                            boxShadow:
                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                            backgroundColor: "green",
                            color: "#fff",
                            "&:hover": {
                              boxShadow:
                                "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                              backgroundColor: "#14213d",
                              color: "#fff",
                            },
                          }}
                          onClick={activateHouse}
                        />
                      </Grid>
                    ) : null}
                    <Grid item xs={12} md={4}>
                      <ItemCardy>
                        <Grid container spacing={2}>
                          <Grid item xs={12} md={12}>
                            <Typography
                              variant="subtitle"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>Warehouse Current Balance</b>
                            </Typography>
                          </Grid>
                          <Grid item xs={12} md={12}>
                            <Typography
                              variant="h2"
                              textAlign="center"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>
                                {currencyFormat.format(
                                  house?.house_details?.current_balance
                                    ? house?.house_details?.current_balance
                                    : 0
                                )}
                              </b>
                            </Typography>
                          </Grid>
                          <Grid item xs={12} md={12}>
                            <Divider variant="middle" sx={{ m: 1 }} />
                            <Box sx={{ display: "flex", flexDirection: "row" }}>
                              {/* <Chip 
                                                                    size='small'
                                                                    label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Fund Account</b></Typography>}
                                                                    sx={{
                                                                        borderRadius:2,
                                                                        m: 1,
                                                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                                                        backgroundColor: 'green',
                                                                        color:'#fff',
                                                                        '&:hover': {
                                                                            boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                                                            backgroundColor:'#14213d',
                                                                            color:'#fff'
                                                                        },
                                                                    }} 
                                                                    onClick={() => handleOpenModal(1)}
                                                                /> */}
                              <Chip
                                size="small"
                                label={
                                  <Typography
                                    variant="subtitle"
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                  >
                                    <b>Release funds</b>
                                  </Typography>
                                }
                                sx={{
                                  borderRadius: 2,
                                  m: 1,
                                  boxShadow:
                                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                  backgroundColor: "orange",
                                  color: "#000",
                                  "&:hover": {
                                    boxShadow:
                                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                    backgroundColor: "#14213d",
                                    color: "#fff",
                                  },
                                }}
                                onClick={() => handleOpenModal(2)}
                              />
                              <Chip
                                size="small"
                                label={
                                  <Typography
                                    variant="subtitle"
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                  >
                                    <b>Go To Society Warehouse</b>
                                  </Typography>
                                }
                                sx={{
                                  borderRadius: 2,
                                  m: 1,
                                  boxShadow:
                                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                  backgroundColor: "brown",
                                  color: "#fff",
                                  "&:hover": {
                                    boxShadow:
                                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                    backgroundColor: "#14213d",
                                    color: "#fff",
                                  },
                                }}
                                onClick={visitAccount}
                              />
                            </Box>
                          </Grid>
                        </Grid>
                      </ItemCardy>
                      <ItemCardy>
                        <Grid container spacing={2}>
                          <Grid item xs={12} md={12}>
                            <Typography
                              variant="h4"
                              textAlign="center"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>Crops</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Current Bags held: {house?.total_bags}</b>
                            </Typography>
                            <Typography
                              sx={{ color: "red" }}
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>
                                Unsettled Balance:{" "}
                                {currencyFormat.format(house?.total_balance)}
                              </b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>
                                Number of unsettled loans:{" "}
                                {house?.unsettled_acts}
                              </b>
                            </Typography>
                            {/* <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Total Bags held: house?.house_details?</b></Typography>   
                                                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Total Bags held: house?.house_details?</b></Typography>    */}
                          </Grid>
                        </Grid>
                      </ItemCardy>
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                          <Divider>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>
                                Ongoing Trades
                              </b>
                            </Typography>
                          </Divider>
                          {
                            ongoing_deals[0]?
                              <Box 
                                sx={{ 
                                    display:'flex',
                                    overflowX: 'auto', 
                                    marginTop:'5px',
                                    maxWidth: 1400, 
                                    '&::-webkit-scrollbar': {
                                      height: '5px',
                                    },
                                    '&::-webkit-scrollbar-track': {
                                        background: '#f1f1f1',
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        background: '#888',
                                        borderRadius: '10px',
                                    },
                                    '&::-webkit-scrollbar-thumb:hover': {
                                        background: '#555',
                                    }
                                }}
                              >
                                {
                                  ongoing_deals && ongoing_deals.map((item) => (
                                    <Chip 
                                      size='small'
                                      label={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{item.commodity}({item.bags})</b></Typography>}
                                      variant={one_deal && one_deal === item.trade_id ? "filled" : "outlined"}
                                          sx={{
                                            m: 1,
                                            borderRadius:2,
                                            boxShadow:
                                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                            backgroundColor:
                                            one_deal && one_deal === item.trade_id ? "#fff" : "#344e41",
                                            color: one_deal && one_deal === item.trade_id ? "#000" : "#fff",
                                            "&:hover": {
                                              boxShadow:
                                                "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                              backgroundColor: "#14213d",
                                              color: "#000",
                                            },
                                          }}
                                      onClick={() => mobilize(item)}
                                    />
                                  ))
                                }
                              </Box>
                              :
                              <Typography sx={{textAlign:'center'}} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>
                                No current ongoing trades in warehouse
                                </b></Typography>
                          }
                          <Divider>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>
                                Closed Trades
                              </b>
                            </Typography>
                          </Divider>
                          {
                            closed_deals[0]?
                              <Box 
                                sx={{ 
                                    display:'flex',
                                    overflowX: 'auto', 
                                    marginTop:'5px',
                                    maxWidth: 1400, 
                                    '&::-webkit-scrollbar': {
                                      height: '5px',
                                    },
                                    '&::-webkit-scrollbar-track': {
                                        background: '#f1f1f1',
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        background: '#888',
                                        borderRadius: '10px',
                                    },
                                    '&::-webkit-scrollbar-thumb:hover': {
                                        background: '#555',
                                    }
                                }}
                              >
                                {
                                  closed_deals && closed_deals.map((item) => (
                                    <Chip 
                                      size='small'
                                      label={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{item.commodity}({item.bags})</b></Typography>}
                                      variant={one_deal && one_deal === item.trade_id ? "filled" : "outlined"}
                                          sx={{
                                            m: 1,
                                            borderRadius:2,
                                            boxShadow:
                                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                            backgroundColor:
                                            one_deal && one_deal === item.trade_id ? "gray" : "#344e41",
                                            color: one_deal && one_deal === item.trade_id ? "#000" : "#fff",
                                            "&:hover": {
                                              boxShadow:
                                                "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                              backgroundColor: "#14213d",
                                              color: "#000",
                                            },
                                          }}
                                      onClick={() => mobilize(item)}
                                    />
                                  ))
                                }
                              </Box>
                              :
                              <Typography sx={{textAlign:'center'}} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>
                                No closed trades in warehouse
                                </b></Typography>
                          }

                        </Grid>

                        <Grid item xs={12} md={12}>
                          {
                            one_deal.trade_id?
                              <Grid container spacing={2}>
                                <Grid item xs={12} md={12}>
                                  <Ittem>
                                    <Box>
                                      <Typography variant='h4' sx={{textAlign:'center'}} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>
                                          Deal Details
                                        </b>
                                      </Typography>
                                    </Box>
                                    <Box
                                      sx={{
                                        display:'flex',
                                        flexDirection:'row'
                                      }}
                                    >
                                      <Box 
                                        sx={{
                                          display:'block',
                                          marginRight:'auto'
                                        }}
                                      >
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>
                                            Commodity: {one_deal?.commodity}
                                          </b>
                                        </Typography>
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>
                                            Number of Bags: {one_deal?.bags}
                                          </b>
                                        </Typography>
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>
                                            Grade: {one_deal?.grade}
                                          </b>
                                        </Typography>
                                      </Box>
                                      <Box
                                        sx={{
                                          display:'block',
                                          marginRight:'auto'
                                        }}
                                      >
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>
                                            Unit: {one_deal?.unit}
                                          </b>
                                        </Typography>
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>
                                            Pick Up Point: {one_deal?.pick_up_point === 'Local Warehouse'?'Here':'Main Warehouse'}
                                          </b>
                                        </Typography>
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>
                                            Deal Status: {one_deal?.trade_status}
                                          </b>
                                        </Typography>
                                      </Box>
                                      <Box
                                        sx={{
                                          display:'block'
                                        }}
                                      >
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>
                                            Total Amount: {currencyFormat.format(one_deal?.price)}
                                          </b>
                                        </Typography>
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>
                                            Selling Bag Price(single): {currencyFormat.format(one_deal?.price / one_deal?.bags)}
                                          </b>
                                        </Typography>
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>
                                            Bags Mobilized: {one_deal?.bags_mobilized}
                                          </b>
                                        </Typography>
                                      </Box>
                                    </Box>
                                  </Ittem>
                                </Grid>
                                {
                                  one_deal?.satisfied === true && one_deal?.trade_status !== "Closed" && one_deal?.pick_up_point !== "Main Warehouse"?
                                    <Ittem>
                                      <Box
                                        sx={{
                                          display:'block'
                                        }}
                                      >
                                          <Typography variant="h4" sx={{textAlign:'center'}} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>
                                              {one_deal?.bags_mobilized} bags ready for pick up.
                                            </b>
                                          </Typography>
                                          <Box 
                                            sx={{
                                              display:'flex',
                                              justifyContent:'center',
                                              alignItems:'centers'
                                            }}
                                          >
                                            <Chip  
                                              size='small'
                                              label={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Confirm Pickup</b></Typography>}
                                              color="success"
                                              sx={{
                                                borderRadius:2,
                                                m:1,
                                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                                '&:hover': {
                                                  boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                                },
                                              }} 
                                              onClick={() => satisfied_action('pick_up')} 
                                            />
                                            <Chip  
                                              size='small'
                                              label={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Move To Main Warehouse</b></Typography>}
                                              color="success"
                                              sx={{
                                                borderRadius:2,
                                                m:1,
                                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                                '&:hover': {
                                                  boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                                },
                                              }} 
                                              onClick={() => satisfied_action('transfer')} 
                                            />
                                          </Box>
                                      </Box>
                                    </Ittem>
                                  : one_deal?.trade_status !== "Closed" && one_deal?.pick_up_point === "Main Warehouse"?
                                  <>
                                   <Ittem>
                                      <Box
                                        sx={{
                                          display:'block'
                                        }}
                                      >
                                        <Typography variant="h4" sx={{textAlign:'center'}} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>
                                              Vendor Commodities Moved To Main Warehouse.
                                            </b>
                                          </Typography>
                                      </Box>
                                      <Box
                                        sx={{
                                          display:'flex',
                                          justifyContent:'center',
                                          alignItems:'centers'
                                        }}
                                      >
                                        <Chip  
                                          size='small'
                                          label={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Print Invoice</b></Typography>}
                                          color="success"
                                          sx={{
                                            borderRadius:2,
                                            m:1,
                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                            '&:hover': {
                                              boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                            },
                                          }} 
                                          onClick={printReceipt} 
                                        />
                                      </Box>
                                    </Ittem> 
                                  </>
                                  : one_deal?.trade_status === "Closed" && one_deal?.pick_up_point !== "Main Warehouse" ?
                                  <>
                                    <Ittem>
                                      <Box
                                        sx={{
                                          display:'block'
                                        }}
                                      >
                                        <Typography variant="h4" sx={{textAlign:'center'}} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>
                                              Trade Completed Successfully. Pick Up Confirmed on {formatDateToYearMonthDayTime(new Date(one_deal?.pick_up_date))}
                                            </b>
                                          </Typography>
                                      </Box>
                                      <Box
                                        sx={{
                                          display:'flex',
                                          justifyContent:'center',
                                          alignItems:'centers'
                                        }}
                                      >
                                        <Chip  
                                          size='small'
                                          label={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Print Invoice</b></Typography>}
                                          color="success"
                                          sx={{
                                            borderRadius:2,
                                            m:1,
                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                            '&:hover': {
                                              boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                            },
                                          }} 
                                          onClick={printReceipt} 
                                        />
                                      </Box>
                                    </Ittem>
                                    
                                  </>

                                  :
                                  <Grid item xs={12} md={12}>
                                  <Ittem>
                                    <Grid container spacing={2}>
                                      <Grid item xs={12} md={12}>
                                        <Typography sx={{textAlign:'center'}} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>
                                            Mobilize
                                          </b>
                                        </Typography>
                                      </Grid>

                                      <Grid item xs={12} md={12}>
                                      <Box
                                        sx={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                        }}
                                      >
                                        <CircularProgress
                                          size={80}
                                          color="success"
                                          thickness={5.5}
                                          variant="determinate"
                                          value={((one_elegibility + one_deal?.bags_mobilized) / one_deal?.bags) * 100}
                                        />
                                        <Typography
                                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                          sx={{ marginTop: 1 }}
                                        >
                                          <b>
                                            {one_elegibility + one_deal?.bags_mobilized} / {one_deal?.bags}
                                          </b>
                                        </Typography>
                                        <Typography
                                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                          sx={{ marginTop: 1 }}
                                        >
                                          <b>
                                            {currencyFormat.format(one_deal?.price)} /{' '}
                                            {currencyFormat.format(
                                              (one_elegibility + one_deal?.bags_mobilized) !== 0
                                                ? (one_elegibility + one_deal?.bags_mobilized) * (one_deal?.price / one_deal?.bags)
                                                : 0
                                            )}
                                          </b>
                                        </Typography>
                                      </Box>

                                      </Grid>
                                      <Grid item xs={12} md={12}>
                                        <Divider variant="middle" />
                                      </Grid>
                                      
                                      <Grid item xs={12} md={12}>
                                        <Box>
                                          <Typography
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                            sx={{textAlign:'center'}}
                                          >
                                            <b>
                                              Available bags: {deal_elegible?.total_bags_left}
                                            </b>
                                          </Typography>
                                        </Box>
                                        <Box
                                          sx={{
                                            maxHeight: 300,
                                            overflowY: "auto",
                                            "&::-webkit-scrollbar": {
                                              width: "7px",
                                            },
                                            "&::-webkit-scrollbar-track": {
                                              background: "#f1f1f1",
                                            },
                                            "&::-webkit-scrollbar-thumb": {
                                              background: "#888",
                                              borderRadius: "10px",
                                            },
                                            "&::-webkit-scrollbar-thumb:hover": {
                                              background: "#555",
                                            },
                                          }}
                                        >
                                          <List
                                            // sx={{
                                            //   width: "100%"
                                            // }}
                                          >
                                            {
                                              deal_elegible?.activities && deal_elegible?.activities.map((act) => (
                                                <div key={act.transaction_id}>
                                                  <ListItem
                                                    alignItems="flex-start"
                                                    key={act.transaction_id}
                                                    onDoubleClick={() => {
                                                      if(me_active === act.transaction_id){
                                                        setMe_active(null)
                                                      } else {
                                                        setOne_elegibility(0)
                                                        setMe_active(act.transaction_id)
                                                      }
                                                    }}
                                                    sx={{ color: me_active === act.transaction_id? 'Highlight': null, cursor:'pointer', my:3 }}
                                                    secondaryAction={
                                                      <Box>
                                                        <Box sx={{display:'flex'}}>
                                                          <Typography sx={{color:'black'}} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b>Selecting: {me_active === act.transaction_id?one_elegibility: 0} bags</b>
                                                            {(one_elegibility + one_deal?.bags_mobilized) >= one_deal?.bags?<b style={{color:'red', marginLeft:'5px'}}>Limit Reached</b>:null}
                                                          </Typography>
                                                          <Divider sx={{m:1}} orientation="vertical" flexItem />
                                                          <Typography sx={{color:'black'}} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b>Selected Bags Value: {currencyFormat.format(me_active === act.transaction_id?one_elegibility * (one_deal?.price / one_deal?.bags): 0)}</b>
                                                          </Typography>
                                                        </Box>

                                                        {
                                                          (one_elegibility + one_deal?.bags_mobilized) >= one_deal?.bags?
                                                          <Tooltip title={
                                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                              <b>Limit reached</b>
                                                            </Typography>
                                                          }>
                                                            <PrettoSlider
                                                              valueLabelDisplay="auto"
                                                              aria-label="pretto slider"
                                                              value={me_active === act.transaction_id?one_elegibility: 0}
                                                              onChange={(e) => setOne_elegibility(me_active === act.transaction_id?e.target.value:0)}
                                                              max={(act.retriv_bags !== null?act.retriv_bags:act.amount_of_commodity) < one_deal?.bags ? (act.retriv_bags !== null?act.retriv_bags:act.amount_of_commodity) : one_deal?.bags}
                                                              disabled={me_active !== act.transaction_id}
                                                            />
                                                          </Tooltip>
                                                          :
                                                          <PrettoSlider
                                                            valueLabelDisplay="auto"
                                                            aria-label="pretto slider"
                                                            value={me_active === act.transaction_id?one_elegibility: 0}
                                                            onChange={(e) => setOne_elegibility(me_active === act.transaction_id?e.target.value:0)}
                                                            max={(act.retriv_bags !== null?act.retriv_bags:act.amount_of_commodity) < one_deal?.bags ? (act.retriv_bags !== null?act.retriv_bags:act.amount_of_commodity) : one_deal?.bags}
                                                            disabled={me_active !== act.transaction_id}
                                                          />
                                                        }

                                                        <Chip 
                                                          key={act.transaction_id} 
                                                          size='small'
                                                          label={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Pay {currencyFormat.format(me_active === act.transaction_id?one_elegibility * (one_deal?.price / one_deal?.bags): 0)}</b></Typography>}
                                                          disabled={me_active !== act.transaction_id || (one_elegibility + one_deal?.bags_mobilized) > one_deal?.bags  || !one_elegibility}
                                                          color="success"
                                                          sx={{
                                                            borderRadius:2,
                                                            m:1,
                                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                                            '&:hover': {
                                                              boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                                            },
                                                          }} 
                                                          onClick={handleOpenUserMenu} 
                                                        />
                                                        <Menu
                                                          sx={{ mt: "45px" }}
                                                          id="menu-appbar"
                                                          anchorEl={anchorElUser}
                                                          anchorOrigin={{
                                                            vertical: "top",
                                                            horizontal: "right",
                                                          }}
                                                          keepMounted
                                                          transformOrigin={{
                                                            vertical: "top",
                                                            horizontal: "right",
                                                          }}
                                                          open={Boolean(anchorElUser)}
                                                          onClose={handleCloseUserMenu}
                                                        >
                                                          {
                                                             one_savings && one_savings.map((save) => (
                                                              <MenuItem key={1} onClick={() => payForCommodity(act.transaction_id, save.id)}>
                                                              <Typography
                                                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                                                textAlign="center"
                                                                fontWeight="bold"
                                                              >
                                                                {save.account_name}
                                                              </Typography>
                                                          </MenuItem>
                                                             ))
                                                          }
                                                          
                                                        </Menu>
                                                      </Box>
                                                    }
                                                  >
                                                    <ListItemText
                                                      primary={<Typography variant={me_active === act.transaction_id?'h4': 'h6'} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                      <b>{act.firstname}{" "}{act.lastname?act.lastname:''}</b>
                                                    </Typography>}
                                                      secondary={
                                                        <Box sx={{ display: "block" }}>
                                                          <div>
                                                            <Typography
                                                              sx={{ display: "inline" }}
                                                              component="span"
                                                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                                              color={me_active === act.transaction_id?"text.primary":null}
                                                            >
                                                              <b>Available Bags: {act.retriv_bags !== null?act.retriv_bags:act.amount_of_commodity}</b>
                                                            </Typography>
                                                          </div>
                                                          <div>
                                                            <Typography
                                                              sx={{ display: "inline" }}
                                                              component="span"
                                                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                                              color={me_active === act.transaction_id?"text.primary":null}
                                                            >
                                                              <b>Value: {currencyFormat.format((act.retriv_bags !== null?act.retriv_bags:act.amount_of_commodity) * (one_deal?.price / one_deal?.bags))}</b>
                                                            </Typography>
                                                          </div>
                                                        </Box>
                                                      }
                                                    />
                                                  </ListItem>
                                                  <Divider variant="middle" />
                                                </div>
                                              ))
                                            }
                                          </List>
                                        </Box>
                                      </Grid>

                                    </Grid>
                                  </Ittem>
                                </Grid>
                                }
                                
                              </Grid>
                            :null
                          }
                        </Grid>
                      </Grid>
                      <Modal
                                      open={open_modal_print}
                                      onClose={closeModalReceipt}
                                      aria-labelledby="modal-modal-title"
                                      aria-describedby="modal-modal-description"
                                    >
                                      <Box sx={style_print}>
                                        <Grid container spacing={2}>
                                          <Grid item xs={12} md={12}>
                                            <Box sx={{ display: "flex", flexDirection: "row" }}>
                                              <Chip
                                                size="medium"
                                                label={
                                                  <Typography
                                                    variant="subtitle"
                                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                                  >
                                                    <b>Print</b>
                                                  </Typography>
                                                }
                                                sx={{
                                                  borderRadius: 2,
                                                  mr: "auto",
                                                  boxShadow:
                                                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                                  backgroundColor: "orange",
                                                  color: "#000",
                                                  "&:hover": {
                                                    boxShadow:
                                                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                    backgroundColor: "#14213d",
                                                    color: "#fff",
                                                  },
                                                }}
                                                onClick={handlePrinter}
                                              />
                                              <Chip
                                                size="medium"
                                                label={
                                                  <Typography
                                                    variant="subtitle"
                                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                                  >
                                                    <b>Close</b>
                                                  </Typography>
                                                }
                                                sx={{
                                                  borderRadius: 2,
                                                  ml: "auto",
                                                  boxShadow:
                                                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                                  backgroundColor: "red",
                                                  color: "#fff",
                                                  "&:hover": {
                                                    boxShadow:
                                                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                    backgroundColor: "#14213d",
                                                    color: "#fff",
                                                  },
                                                }}
                                                onClick={closeModalReceipt}
                                              />
                                            </Box>
                                          </Grid>
                                          <Grid item xs={12} md={12}>
                                            <Grid container spacing={2} ref={printRefer}>
                                              <Grid item xs={12} md={12}>
                                                <Typography
                                                  variant="subtitle"
                                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                                  textAlign="center"
                                                  sx={{ color: "grey", mb: 3, ml: "43%" }}
                                                >
                                                  <b>~ The Cooperative ~</b>
                                                </Typography>
                                              </Grid>
                                              <Grid item xs={12} md={12}>
                                                <Avatar
                                                  src={KPeeLogo}
                                                  alt="KPee logo"
                                                  sx={{ width: 120, height: 120, m: "auto" }}
                                                />
                                              </Grid>
                                              <Grid item xs={12} md={12}>
                                                <Typography
                                                  variant="h3"
                                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                                  sx={{ textAlign: "center" }}
                                                >
                                                  <b>{society_name}</b>
                                                </Typography>
                                                <Typography
                                                  sx={{textAlign:'center'}}
                                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                                >
                                                  <b>{formatDateToYearMonthDayTime(new Date())}</b>
                                                </Typography>
                                              </Grid>

                                              <Grid item xs={12} md={12}>
                                                <Typography
                                                  sx={{ textAlign: "center", textDecoration: "underline" }}
                                                  variant="h4"
                                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                                >
                                                  <b>Vendor</b>
                                                </Typography>

                                                <Typography variant="h5" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                  <b>Name:{" "} {one_deal?.vendor_name}</b>
                                                </Typography>
                                                {/* <Divider variant="middle" /> */}
                                                <Typography variant="h5" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                  <b>Email:{" "} {one_deal?.email}</b>
                                                </Typography>
                                                {/* <Divider variant="middle" /> */}
                                                <Typography variant="h5" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                  <b>Phone Contact:{" "} {one_deal?.phone}</b>
                                                </Typography>
                                              </Grid>

                                              <Grid item xs={12} md={12}>
                                                <Typography
                                                  sx={{ textAlign: "center", textDecoration: "underline" }}
                                                  variant="h4"
                                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                                >
                                                  <b>Trade Deal</b>
                                                </Typography>

                                                <Typography variant="h5" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                  <b>Commodity:{" "} {one_deal?.commodity}</b>
                                                </Typography>
                                                {/* <Divider variant="middle" /> */}
                                                <Typography variant="h5" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                  <b>
                                                    Number of Bags:{" "}
                                                    {currencyFormat.format(one_deal?.bags)}
                                                  </b>
                                                </Typography>
                                                {/* <Divider variant="middle" /> */}
                                                <Typography variant="h5" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                  <b>
                                                    Commodity Grade:{" "} {one_deal?.grade}
                                                  </b>
                                                </Typography>
                                                {/* <Divider variant="middle" /> */}
                                                <Typography variant="h5" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                  <b>Commodity Bag Unit: {one_deal?.unit}kg</b>
                                                </Typography>
                                                {/* <Divider variant="middle" /> */}
                                                <Typography variant="h5" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                  <b>Pick Up Point:{" "} {one_deal?.pick_up_point === 'Local Warehouse'?warehouse_name:'Main Warehouse'}</b>
                                                </Typography>
                                                {/* <Divider variant="middle" /> */}
                                                <Typography variant="h5" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                  <b>Pick Up Date:{" "} {one_deal?.pick_up_date?formatDateToYearMonthDayTime(new Date(one_deal?.pick_up_date)):'Not Confirmed'}</b>
                                                </Typography>
                                                {/* <Divider variant="middle" /> */}
                                                <Typography variant="h5" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                  <b>Amount Paid: {currencyFormat.format(one_deal?.price)}</b>
                                                </Typography>
                                                <Typography variant="h5" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                  <b>
                                                    Selling Bag Price(single):{" "} {currencyFormat.format(one_deal?.price / one_deal?.bags)}
                                                  </b>
                                                </Typography>
                                                {/* <Divider variant="middle" /> */}
                                              </Grid>

                                              <Grid item xs={12} md={12}>
                                                <Typography variant="h5" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                  <b>Deal Status:{" "} {one_deal?.trade_status}</b>
                                                </Typography>
                                              </Grid>
                                              
                                              <Grid  item xs={12} md={12}>
                                                <Typography sx={{textAlign:'center', mt:5}} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                  <b>It was a pleasure doing business with you.</b>
                                                </Typography>
                                              </Grid>
                                            </Grid>

                                          </Grid>
                                        </Grid>
                                        
                                      </Box>
                                    </Modal>
                      {/* <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          overflowY: "auto",
                          maxHeight: 300,
                          "&::-webkit-scrollbar": {
                            width: "7px",
                          },
                          "&::-webkit-scrollbar-track": {
                            background: "#f1f1f1",
                          },
                          "&::-webkit-scrollbar-thumb": {
                            background: "#888",
                            borderRadius: "10px",
                          },
                          "&::-webkit-scrollbar-thumb:hover": {
                            background: "#555",
                          },
                        }}
                      >
                        {house?.house_activities?.map((act) => (
                          <ItemCardy>
                            <Box sx={{ display: "flex" }}>
                              <Typography
                                sx={{ m: 1 }}
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              >
                                <b>Crop:</b>{" "}
                                <div>
                                  <b>{act.commodity}</b>
                                </div>
                              </Typography>
                              <Divider
                                sx={{ ml: 2, mr: 2 }}
                                variant="middle"
                                orientation="vertical"
                                flexItem
                              />
                              <Typography
                                sx={{ m: 1 }}
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              >
                                <b>Quantity:</b>{" "}
                                <div>
                                  <b>{act.bags}</b>
                                </div>
                              </Typography>
                              <Divider
                                sx={{ ml: 2, mr: 2 }}
                                variant="middle"
                                orientation="vertical"
                                flexItem
                              />
                              <Typography
                                sx={{ m: 1 }}
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              >
                                <b>Unit:</b>{" "}
                                <div>
                                  <b>{act.unit_per_kg}</b>
                                </div>
                              </Typography>
                              <Divider
                                sx={{ ml: 2, mr: 2 }}
                                variant="middle"
                                orientation="vertical"
                                flexItem
                              />
                              <Typography
                                sx={{ m: 1 }}
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              >
                                <b>Grade:</b>{" "}
                                <div>
                                  <b>{act.grade}</b>
                                </div>
                              </Typography>
                              <Divider
                                sx={{ ml: 2, mr: 2 }}
                                variant="middle"
                                orientation="vertical"
                                flexItem
                              />
                              <Typography
                                sx={{ m: 1 }}
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              >
                                <b>Recorded On:</b>{" "}
                                <div>
                                  <b>
                                    {formatDateToYearMonthDay(
                                      new Date(act.income_date)
                                    )}
                                  </b>
                                </div>
                              </Typography>
                              <Divider
                                sx={{ ml: 2, mr: 2 }}
                                variant="middle"
                                orientation="vertical"
                                flexItem
                              />
                              <Typography
                                sx={{ m: 1 }}
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              >
                                <b>Farmer Balance:</b>{" "}
                                <div
                                  style={{
                                    color: act.balance > 0 ? "red" : "black",
                                  }}
                                >
                                  <b>{currencyFormat.format(act.balance)}</b>
                                </div>
                              </Typography>
                              <Divider
                                sx={{ ml: 2, mr: 2 }}
                                variant="middle"
                                orientation="vertical"
                                flexItem
                              />
                              <Typography
                                sx={{ m: 1 }}
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              >
                                {act.transfer_date ? (
                                  <Tooltip
                                    title={`Transfered on ${formatDateToYearMonthDay(
                                      new Date(act.transfer_date)
                                    )}`}
                                  >
                                    <Chip
                                      size="small"
                                      disabled
                                      label={
                                        <Typography
                                          variant="subtitle"
                                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        >
                                          <b>Released</b>
                                        </Typography>
                                      }
                                      sx={{
                                        borderRadius: 3,
                                        boxShadow:
                                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                        backgroundColor: "#2b2d42",
                                        color: "#fff",
                                        "&:hover": {
                                          boxShadow:
                                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                          backgroundColor: "#14213d",
                                        },
                                      }}
                                    />
                                  </Tooltip>
                                ) : (
                                  <Chip
                                    size="small"
                                    label={
                                      <Typography
                                        variant="subtitle"
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                      >
                                        <b>
                                          {act.balance === 0
                                            ? "Release to Society Warehouse"
                                            : "Settle Balance"}
                                        </b>
                                      </Typography>
                                    }
                                    sx={{
                                      borderRadius: 3,
                                      boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                      backgroundColor: "#2b2d42",
                                      color: "#fff",
                                      "&:hover": {
                                        boxShadow:
                                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                      },
                                    }}
                                    onClick={() =>
                                      actionDem(act.id, act.balance)
                                    }
                                  />
                                )}
                              </Typography>
                            </Box>
                          </ItemCardy>
                        ))}
                      </Box> */}
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <Typography
                        variant="h4"
                        sx={{ textAlign: "center", m: 5 }}
                      >
                        Account Records
                      </Typography>
                      <Box
                        sx={{
                          m: 1,
                          overflowY: "auto",
                          maxHeight: 600,
                          "&::-webkit-scrollbar": {
                            width: "7px",
                          },
                          "&::-webkit-scrollbar-track": {
                            background: "#f1f1f1",
                          },
                          "&::-webkit-scrollbar-thumb": {
                            background: "#888",
                            borderRadius: "10px",
                          },
                          "&::-webkit-scrollbar-thumb:hover": {
                            background: "#555",
                          },
                        }}
                      >
                        <Table size="small" aria-label="a dense table">
                          <TableHead>
                            <TableRow>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Date</b>
                                </Typography>{" "}
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Kind</b>
                                </Typography>{" "}
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Debit</b>
                                </Typography>{" "}
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Credit</b>
                                </Typography>{" "}
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Balance</b>
                                </Typography>{" "}
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Prepared by</b>
                                </Typography>{" "}
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Narration</b>
                                </Typography>{" "}
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {house?.house_transactions?.map((row) => (
                              <TableRow
                                key={row.transaction_id}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                  backgroundColor: "#f5f3f4",
                                }}
                              >
                                <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>
                                      {formatDateToYearMonthDayTime(
                                        new Date(row.date)
                                      )}
                                    </b>
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>{row.transaction_kind}</b>
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>
                                      {row.transaction_type === 2
                                        ? currencyFormat.format(row.amount)
                                        : currencyFormat.format(0)}
                                    </b>
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>
                                      {row.transaction_type === 1
                                        ? currencyFormat.format(row.amount)
                                        : currencyFormat.format(0)}
                                    </b>
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>{currencyFormat.format(row.balance)}</b>
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>{row.username}</b>
                                  </Typography>
                                </TableCell>
                                <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>{row.narration}</b>
                                  </Typography>
                                </TableCell>
                                {/* <TableCell align="left">
                                                                        <Box  sx={{ display:'flex', flexDirection:'row' }}>
                                                                        
                                                                        <Tooltip title={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>NB: This feature will check if the amount invested still exist in society account before deleting. It will ignore if society account does not have sufficient balance to be deducted.</b></Typography>}>
                                                                            <Chip 
                                                                            size='small'
                                                                            label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Delete</b></Typography>}
                                                                            sx={{
                                                                                borderRadius:2,
                                                                                m:'5px',
                                                                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                                                                backgroundColor: 'red',
                                                                                color:'#fff',
                                                                                '&:hover': {
                                                                                    boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                                                                    backgroundColor:'#14213d',
                                                                                },
                                                                            }} 
                                                                            />
                                                                        </Tooltip>
                                                                        
                                                                        </Box>
                                                                        

                                                                    </TableCell> */}
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </Box>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>

            <Grid item xs={12} md={4}>
              <Accordion
                sx={{
                  mb: 1,
                  borderRadius: 3,
                  boxShadow:
                    "0 4px 8px rgba(0, 0, 0, 0.2), 0 4px 10px rgba(0, 0, 0, 0.2)",
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="h5"
                    sx={{ color: "darkblue" }}
                  >
                    <b>Loans</b>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {loan_data_ini && loan_data_ini.eget === true ? (
                    <Box>
                      <Typography
                        variant="h5"
                        sx={{ textAlign: "center" }}
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>{warehouse_name} Loans</b>
                      </Typography>
                      <Box sx={{ display: "block" }}>
                        <div style={{ display: "flex", marginTop: "5px" }}>
                          <Typography
                            sx={{ textAlign: "center" }}
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>
                              Interest percentage per annum:{" "}
                              {loan_data_ini.data?.interest_amt_yr
                                ? loan_data_ini?.data?.interest_amt_yr
                                : "N/A"}
                              %
                            </b>
                          </Typography>
                        </div>
                        <div style={{ display: "flex", marginTop: "5px" }}>
                          <Typography
                            sx={{ textAlign: "center" }}
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>
                              Proccessing fee percentage:{" "}
                              {loan_data_ini.data?.proccessing_fee
                                ? loan_data_ini?.data?.proccessing_fee
                                : "N/A"}
                              % (of requested amount)
                            </b>
                          </Typography>
                        </div>
                        <div style={{ display: "flex", marginTop: "5px" }}>
                          <Typography
                            sx={{ textAlign: "center" }}
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>
                              Application fee percentage:{" "}
                              {loan_data_ini.data?.application_fee
                                ? loan_data_ini?.data?.application_fee
                                : "N/A"}
                              % (of requested amount)
                            </b>
                          </Typography>
                        </div>
                        <div style={{ display: "flex", marginTop: "5px" }}>
                          <Typography
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            variant="h6"
                          >
                            <b>make changes</b>
                            <IconButton onClick={setupLoan}>
                              <SettingsIcon />
                            </IconButton>
                          </Typography>
                        </div>
                      </Box>
                      <Box
                        sx={{
                          maxWidth: 430,
                          overflowX: "auto",
                          maxHeight: 240,
                          overflowY: "auto",
                          "&::-webkit-scrollbar": {
                            width: "7px",
                          },
                          "&::-webkit-scrollbar-track": {
                            background: "#f1f1f1",
                          },
                          "&::-webkit-scrollbar-thumb": {
                            background: "#888",
                            borderRadius: "10px",
                          },
                          "&::-webkit-scrollbar-thumb:hover": {
                            background: "#555",
                          },
                        }}
                      >
                        <Table
                          sx={{ width: 999 }}
                          size="small"
                          aria-label="a dense table"
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell>Date</TableCell>
                              <TableCell align="right">Member</TableCell>
                              <TableCell align="right">Amount</TableCell>
                              <TableCell align="right">Status</TableCell>
                              <TableCell align="right">Prepared_by</TableCell>
                              <TableCell align="right">Savings Group</TableCell>
                              <TableCell align="right">Passbook</TableCell>
                              <TableCell align="right">Type</TableCell>
                              <TableCell align="right">Print Advise</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {loans_orders
                              .slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                              )
                              .map((row) => (
                                <TableRow
                                  key={row.transaction_id}
                                  sx={{
                                    "&:last-child td, &:last-child th": {
                                      border: 0,
                                    },
                                    backgroundColor: "#f5f3f4",
                                  }}
                                >
                                  <TableCell>
                                    <FormatedDate
                                      value={row.transaction_date}
                                    />
                                  </TableCell>
                                  <TableCell align="right">{`${row.firstname} ${row.lastname}`}</TableCell>
                                  <TableCell align="right">
                                    {currencyFormat.format(row.amount)}
                                  </TableCell>
                                  <TableCell align="right">
                                    {row.status}
                                  </TableCell>
                                  <TableCell align="right">
                                    {row.username}
                                  </TableCell>
                                  <TableCell align="right">
                                    {row.association_name}
                                  </TableCell>
                                  <TableCell align="right">
                                    {row.passbook_id}
                                  </TableCell>
                                  <TableCell align="right">
                                    <b
                                      style={{
                                        color:
                                          row.transactiontype_id === 1
                                            ? "blue"
                                            : "red",
                                      }}
                                    >
                                      {row.transactiontype_id === 1
                                        ? "Repayment"
                                        : "Not repayment"}
                                    </b>
                                  </TableCell>
                                  <TableCell align="right">
                                    {row.status === "Disbursed" ? (
                                      <IconButton
                                        onClick={() =>
                                          handleReciept(row.transaction_id)
                                        }
                                      >
                                        <PrintOutlinedIcon />
                                      </IconButton>
                                    ) : null}
                                  </TableCell>
                                  {/* <TableCell align="right"><Tooltip title="Cancel order"><IconButton onClick={()=>handleCancelOrder(row.order_id)}><CancelIcon /></IconButton></Tooltip></TableCell> */}
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                        <TablePagination
                          rowsPerPageOptions={[10, 25, 100]}
                          component="div"
                          count={loans_orders.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                      </Box>
                      {opennn}
                    </Box>
                  ) : (
                    <Typography
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      variant="h6"
                    >
                      <b>Setup warehouse loan details</b>
                      <IconButton onClick={setupLoan}>
                        <SettingsIcon />
                      </IconButton>
                    </Typography>
                  )}
                  {loan_field ? (
                    <Box sx={{ display: "block" }}>
                      <form onSubmit={formik.handleSubmit}>
                        <TextField
                          size="small"
                          label="Interest rate percentage(%/pa)"
                          type="number"
                          fullWidth
                          name="interest_per"
                          sx={{ mb: 1 }}
                          onChange={formik.handleChange}
                          value={formik.values.interest_per}
                          // onBlur={formik.handleBlur}
                          error={
                            formik.touched.interest_per &&
                            Boolean(formik.errors.interest_per)
                          }
                          helperText={
                            formik.touched.interest_per &&
                            formik.errors.interest_per
                          }
                        />
                        <TextField
                          size="small"
                          label="Proccessing fee(% of amount)"
                          type="number"
                          fullWidth
                          name="processing_per"
                          sx={{ mb: 1 }}
                          onChange={formik.handleChange}
                          value={formik.values.processing_per}
                          // onBlur={formik.handleBlur}
                          error={
                            formik.touched.processing_per &&
                            Boolean(formik.errors.processing_per)
                          }
                          helperText={
                            formik.touched.processing_per &&
                            formik.errors.processing_per
                          }
                        />
                        <TextField
                          size="small"
                          label="Application fee(% of amount)"
                          type="number"
                          name="application_per"
                          fullWidth
                          sx={{ mb: "3px" }}
                          onChange={formik.handleChange}
                          value={formik.values.application_per}
                          // onBlur={formik.handleBlur}
                          error={
                            formik.touched.application_per &&
                            Boolean(formik.errors.application_per)
                          }
                          helperText={
                            formik.touched.application_per &&
                            formik.errors.application_per
                          }
                        />
                        <div style={{ display: "flex" }}>
                          <Button
                            variant="contained"
                            sx={{ m: "5px" }}
                            color="error"
                            size="small"
                            onClick={() => setLoan_field(false)}
                          >
                            Close
                          </Button>
                          <Button
                            type="submit"
                            variant="contained"
                            sx={{ m: "5px" }}
                            color="success"
                            size="small"
                          >
                            {loading ? <CircularProgress size={20} /> : "Save"}
                          </Button>
                        </div>
                      </form>
                    </Box>
                  ) : null}
                </AccordionDetails>
              </Accordion>

              {/* Negotiations */}
              <Itemb>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={12}>
                    {/* chats header */}
                    <Typography
                      sx={{ color: "darkblue", textAlign: "center", mb: 1 }}
                      variant="h5"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>Negotiations</b>
                    </Typography>
                  </Grid>
                  {/* search */}
                  <Grid item xs={12} md={12}>
                    <input
                      placeholder="Search..."
                      style={{
                        width: "100%",
                        borderRadius: 18,
                        border: "1px solid #ced4da",
                        padding: "2vh",
                      }}
                      name="search"
                    />
                  </Grid>
                  <Divider variant="fullWidth" sx={{ mt: 1, mb: "5px" }} />

                  <List
                    sx={{
                      width: "100%",
                      maxHeight: 400,
                      overflowY: "scroll",
                      "&::-webkit-scrollbar": {
                        width: "7px",
                      },
                      "&::-webkit-scrollbar-track": {
                        background: "#f1f1f1",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        background: "#888",
                        borderRadius: "10px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        background: "#555",
                      },
                    }}
                  >
                    {chats[0] ? (
                      chats.map((item) => (
                        <>
                          <ListItemButton
                            onClick={() =>
                              openMessages(
                                item.nego_id,
                                item.username,
                                item.user_image,
                                item.user_phone,
                                item.agreed_price,
                                item.agree,
                                item.nego_status,
                                item.order_id
                              )
                            }
                          >
                            <ListItem
                              secondaryAction={
                                item?.last_message?.read === false &&
                                item?.how === "go" ? (
                                  <Tooltip title="Unread">
                                    <DoneIcon />
                                  </Tooltip>
                                ) : item?.last_message?.read === true &&
                                  item?.how === "go" ? (
                                  <Tooltip title="Read">
                                    <DoneAllIcon sx={{ color: "#5887ff" }} />
                                  </Tooltip>
                                ) : item?.last_message?.read === false &&
                                  item?.how === "come" ? (
                                  <Tooltip title="Unread">
                                    <Badge
                                      badgeContent={item.unread}
                                      color="success"
                                    />
                                  </Tooltip>
                                ) : item?.last_message?.read === true &&
                                  item?.how === "come" ? (
                                  <Tooltip title="Read">
                                    <DoneAllIcon sx={{ color: "#5887ff" }} />
                                  </Tooltip>
                                ) : null
                              }
                              alignItems="flex-start"
                            >
                              <ListItemAvatar>
                                <Avatar
                                  alt={item.username}
                                  src={pic(item.user_image)}
                                />
                              </ListItemAvatar>
                              <ListItemText
                                primary={item.username}
                                secondary={
                                  <React.Fragment>
                                    <Typography
                                      sx={{ display: "inline" }}
                                      component="span"
                                      variant="body2"
                                      color="text.primary"
                                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    >
                                      <Chip
                                        label={`Negotiation ${item.nego_status}`}
                                        size="small"
                                        color={
                                          item.nego_status === "Ongoing"
                                            ? "secondary"
                                            : item.nego_status === "Success"
                                            ? "success"
                                            : "error"
                                        }
                                        variant="filled"
                                      />
                                    </Typography>
                                    <div>
                                      {item?.last_message?.message.length > 50
                                        ? item?.last_message?.message?.slice(
                                            0,
                                            50
                                          ) + "..."
                                        : item?.last_message?.message}
                                    </div>
                                  </React.Fragment>
                                }
                              />
                            </ListItem>
                          </ListItemButton>
                          <Divider variant="inset" component="li" />
                        </>
                      ))
                    ) : (
                      <Typography
                        variant="subtitle"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        sx={{ margin: "auto" }}
                      >
                        <CircularProgress size={10} />
                        <b>
                          {" "}
                          No open chats (Consider setting agregators for
                          warehouse with orders)
                        </b>
                      </Typography>
                    )}
                  </List>
                </Grid>
              </Itemb>
            </Grid>

            <Grid item xs={12} sx={{ marginBottom: "30px" }} md={2}>
              <Itemb>
                <Typography>
                  Total bags:{" "}
                  <span style={{ fontWeight: "700", color: "darkblue" }}>
                    {number_of_members}
                  </span>
                </Typography>
                <Typography>
                  Cash worth:{" "}
                  <span style={{ fontWeight: "700", color: "darkblue" }}>
                    {cash_worth > 0 ? currencyFormat.format(cash_worth) : "N/A"}
                  </span>
                </Typography>
                <Typography>
                  Community:{" "}
                  <span style={{ fontWeight: "700", color: "darkblue" }}>
                    {warehouseBasics.community}
                  </span>
                </Typography>
                <Typography>
                  Aggregator:{" "}
                  <span style={{ fontWeight: "700", color: "darkblue" }}>
                    {aggregator}
                  </span>
                </Typography>
                <Typography>
                  {aggregator === "Not assigned"
                    ? "Assign Aggregator"
                    : "Change Aggregator"}
                  :
                  <IconButton onClick={openSetAggregator}>
                    <Person2Icon />
                  </IconButton>
                </Typography>
                <Divider variant="middle" />
                <Typography sx={{ textAlign: "center" }}>
                  <span style={{ fontWeight: "700", color: "dark" }}>
                    Charges (Per bag)
                  </span>
                </Typography>
                <Typography>
                  Rebagging:{" "}
                  <span style={{ fontWeight: "700", color: "darkblue" }}>
                    GH₵{warehouseBasics.rebagging_fee}
                  </span>
                </Typography>
                <Typography>
                  Stacking:{" "}
                  <span style={{ fontWeight: "700", color: "darkblue" }}>
                    GH₵{warehouseBasics.stacking_fee}
                  </span>
                </Typography>
                <Typography>
                  Destoning:{" "}
                  <span style={{ fontWeight: "700", color: "darkblue" }}>
                    GH₵{warehouseBasics.destoning_fee}
                  </span>
                </Typography>
                <Typography>
                  Cleaning*:{" "}
                  <span style={{ fontWeight: "700", color: "darkblue" }}>
                    GH₵{warehouseBasics.cleaning_fee}
                  </span>
                </Typography>
                <Typography>
                  Stitching*:{" "}
                  <span style={{ fontWeight: "700", color: "darkblue" }}>
                    GH₵{warehouseBasics.stitching_fee}
                  </span>
                </Typography>
                <Typography>
                  Loading*:{" "}
                  <span style={{ fontWeight: "700", color: "darkblue" }}>
                    GH₵{warehouseBasics.loading_fee}
                  </span>
                </Typography>
                <Typography>
                  Empty Sack cost*:{" "}
                  <span style={{ fontWeight: "700", color: "darkblue" }}>
                    GH₵{warehouseBasics.empty_sack_cost_fee}
                  </span>
                </Typography>
                <Typography>
                  Storage*:{" "}
                  <span style={{ fontWeight: "700", color: "darkblue" }}>
                    GH₵{warehouseBasics.storage_fee}
                  </span>
                </Typography>
                <Typography>
                  Tax*:{" "}
                  <span style={{ fontWeight: "700", color: "darkblue" }}>
                    GH₵{warehouseBasics.tax_fee}
                  </span>
                </Typography>
                <div style={{ display: "flex" }}>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                    sx={{ color: "#540b0e" }}
                  >
                    <b>Update warehouse and charges:</b>
                    <IconButton onClick={() => setOpen(true)}>
                      <UpdateIcon />
                    </IconButton>
                  </Typography>
                </div>
              </Itemb>
            </Grid>

            <Grid item xs={12} md={3}>
              <Itemb>
                <Typography
                  sx={{
                    fontWeight: "700",
                    color: "darkblue",
                    textAlign: "center",
                  }}
                >
                  Warehouse Commodities
                </Typography>
                <Typography
                  variant="subtitle"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  New Commodity
                </Typography>
                <IconButton sx={{ mb: 1 }} onClick={handle_new_commodity}>
                  <AddBoxIcon />
                </IconButton>
                {new_list}
                <Box sx={{ mt: 2 }}>
                  <Typography
                    variant="subtitle"
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    Available Commodities
                  </Typography>
                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {warehouseCommodities.map((item) => (
                      <Chip
                        key={item.id}
                        label={item.commodity}
                        size="small"
                        icon={<OpenInNewIcon size="small" />}
                        onClick={() =>
                          handleCommodityInfo(item.id, item.commodity)
                        }
                        variant="outlined"
                        color="success"
                        style={{ margin: "4px" }}
                      />
                    ))}
                  </div>
                </Box>
                <Button
                  onClick={toggleDrawer("left", true)}
                  color="success"
                  size="medium"
                  variant="contained"
                  sx={{ mb: 2, mt: 1, mr: 1, borderRadius: 7 }}
                  endIcon={<ViewAgendaIcon />}
                >
                  {orders ? "All Orders" : <CircularProgress size={25} />}
                </Button>
              </Itemb>
            </Grid>

            <Grid item xs={12} md={3}>
              <Itemb>
                <Typography
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  variant="subtitle"
                >
                  Total Members: <b>{all_members_details.length}</b>
                </Typography>
                <div style={{ display: "flex" }}>
                  <Typography
                    variant="subtitle2"
                    fontStyle="oblique"
                    sx={{ color: "#780000", mr: 1 }}
                  >
                    <b>See Members in WareHouse</b>
                  </Typography>
                  {open_members_srch === false ? (
                    <Tooltip title="Click to expand">
                      <AvatarGroup max={5} onClick={handleOpenMembers}>
                        {all_members_details &&
                          all_members_details.map((item) => (
                            <Avatar
                              sx={{ width: 24, height: 24 }}
                              alt={item.name}
                              src={pic(item.image)}
                            />
                          ))}
                      </AvatarGroup>
                    </Tooltip>
                  ) : null}
                </div>
                <div style={{ display: "flex" }}>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="body2"
                    sx={{ color: "#540b0e" }}
                  >
                    <b>Register members to warehouse:</b>
                    <IconButton onClick={handleClickBie}>
                      <AddBoxIcon />
                    </IconButton>
                  </Typography>
                </div>
                <div>
                  {open_members_srch === true ? (
                    <div style={{ display: "flex" }}>
                      <TextField
                        size="small"
                        label="Search Member"
                        name="search_member"
                        value={search_member}
                        onChange={(e) => setSearch_member(e.target.value)}
                        sx={{ mb: 2, mt: 2, borderRadius: 5 }}
                        variant="outlined"
                      />
                      <Tooltip title="Double Click">
                        <IconButton sx={{ mb: 2, mt: 2 }} onClick={fetchInfoo}>
                          <RefreshIcon />
                        </IconButton>
                      </Tooltip>
                    </div>
                  ) : null}
                </div>
                <div style={{ minWidth: 180 }}>
                  <div style={{ display: "flex", m: 2, overflowX: "auto" }}>
                    {open_members}
                  </div>
                </div>
              </Itemb>
              <Itemba>
                <Typography
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  variant="subtitle"
                >
                  <b>Savings Groups related</b> (click to visit)
                </Typography>
                <div style={{ minWidth: 120 }}>
                  <div
                    style={{
                      overflowY: "auto",
                      margin: 1,
                      display: "flex",
                      flexWrap: "wrap",
                    }}
                  >
                    {all_associations ? (
                      (() => {
                        const uniqueAssociationNames = new Set();
                        return all_associations.map((item) => {
                          if (
                            !uniqueAssociationNames.has(item.association_name)
                          ) {
                            uniqueAssociationNames.add(item.association_name);
                            return (
                              <Chip
                                sx={{
                                  m: 1,
                                  backgroundColor: "#1d3557",
                                  color: "fff",
                                }}
                                color="success"
                                key={item.association_id}
                                label={item.association_name}
                                onClick={() =>
                                  visitAssociations(item.association_id)
                                }
                              />
                            );
                          }
                          return null;
                        });
                      })()
                    ) : (
                      <Typography fontStyle="oblique" variant="subtitle">
                        No Savings Group member joined
                      </Typography>
                    )}
                  </div>
                </div>
              </Itemba>
            </Grid>

            {/* <Grid item xs={12} md={6}>

                                        </Grid>
                                        <Grid item xs={12} md={3}>
                                                        
                                        </Grid> */}

            <Grid item xs={12} md={12} sx={{ mb: 3 }}>
              {openCommodities ? (
                openCommodities
              ) : (
                <Typography fontStyle="oblique" variant="subtitle">
                  Select commodity or member for details
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} md={12} sx={{ mb: 10 }}>
              <Itemb>
                <Box sx={{ maxHeight: 500, overflow: "auto" }}>
                  <Typography
                    variant="button"
                    display="block"
                    gutterBottom
                    textAlign="center"
                  >
                    <b>Activities in warehouse</b>
                  </Typography>
                  <>
                    <Typography>Filter Date</Typography>
                    <div style={{ display: "flex" }}>
                      <TextField
                        type="date"
                        size="small"
                        required
                        variant="outlined"
                        helperText="From"
                        name="start_date_all"
                        onChange={(e) => setStart_date_all(e.target.value)}
                        value={start_date_all}
                        sx={{ mr: 1 }}
                      />

                      <TextField
                        type="date"
                        size="small"
                        required
                        variant="outlined"
                        helperText="To"
                        name="end_date_all"
                        onChange={(e) => setEnd_date_all(e.target.value)}
                        value={end_date_all}
                        sx={{ mr: 1 }}
                      />

                      <IconButton sx={{ mb: 2 }} onClick={fetch_all_activities}>
                        <FilterAltOutlinedIcon />
                      </IconButton>
                      <IconButton sx={{ mb: 2 }} onClick={clear_filter_all}>
                        <CancelIcon />
                      </IconButton>
                    </div>
                  </>
                  <Box sx={{ mb: 20 }}>
                    <DataGrid
                      rows={acts_all}
                      columns={columns_all}
                      autoHeight
                      loading={mini_loading}
                      checkboxSelection
                      getRowId={(row) => row.transaction_id}
                      sortingOrder={["desc", "asc"]}
                      sortModel={[
                        {
                          field: "transaction_id",
                          sort: "desc",
                        },
                      ]}
                      slots={{ toolbar: GridToolbar }}
                      initialState={{
                        pagination: { paginationModel: { pageSize: 6 } },
                        columns: {
                          columnVisibilityModel: {
                            transaction_id: false,
                            id: false,
                            association_type: false,
                            lastname: false,
                            firstname: false,
                            account_id: false,
                            member_id: false,
                          },
                        },
                      }}
                      pageSizeOptions={[6, 10, 25]}
                    />
                    <div>
                      <div style={{ display: "flex", padding: "4px" }}>
                        <Typography variant="h6" sx={{ mr: 4 }}>
                          <b>Total:</b>
                        </Typography>
                        <Typography variant="h6" sx={{ mr: 4 }}>
                          <b>
                            Cash Value:{" "}
                            {currencyFormat.format(total_cash_value)}
                          </b>{" "}
                        </Typography>
                        <Typography variant="h6" sx={{ mr: 4 }}>
                          <b>Bags: {total_bags}</b>{" "}
                        </Typography>
                        <Typography variant="h6" sx={{ mr: 4 }}>
                          <b>
                            Cash Balance: {currencyFormat.format(total_balance)}
                          </b>{" "}
                        </Typography>
                      </div>
                    </div>
                  </Box>
                </Box>
              </Itemb>
            </Grid>
          </Grid>

          <Modal
            open={modal_chat}
            onClose={() => setModal_chat(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={chats_style}>{chat_area}</Box>
          </Modal>

          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={openn}
            onClick={handleCloss}
          >
            <CircularProgress color="inherit" />
          </Backdrop>

          <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Update Warehouse Info</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Updating {commoditiesData.warehouse}.
              </DialogContentText>
              <TextField
                required
                margin="dense"
                id="warehouse"
                name="warehouse"
                label="Warehouse"
                onChange={handleInputChange}
                value={commoditiesData.warehouse}
                type="text"
                fullWidth
                variant="outlined"
              />
              <TextField
                required
                margin="dense"
                id="community"
                name="community"
                label="Community Name"
                onChange={handleInputChange}
                type="text"
                value={commoditiesData.community}
                fullWidth
                variant="outlined"
              />
              <TextField
                required
                margin="dense"
                id="rebagging_fee"
                name="rebagging_fee"
                label="Rebagging fee/bag"
                onChange={handleInputChange}
                type="numeric"
                value={commoditiesData.rebagging_fee}
                fullWidth
                variant="outlined"
              />
              <TextField
                required
                margin="dense"
                id="stacking_fee"
                name="stacking_fee"
                label="Stacking fee/bag"
                onChange={handleInputChange}
                type="numeric"
                value={commoditiesData.stacking_fee}
                fullWidth
                variant="outlined"
              />
              <TextField
                required
                margin="dense"
                id="destoning_fee"
                name="destoning_fee"
                label="Destoning fee/bag"
                onChange={handleInputChange}
                type="numeric"
                value={commoditiesData.destoning_fee}
                fullWidth
                variant="outlined"
              />
              <TextField
                required
                margin="dense"
                id="cleaning_fee"
                name="cleaning_fee"
                label="Cleaning f/bag"
                onChange={handleInputChange}
                type="numeric"
                value={commoditiesData.cleaning_fee}
                fullWidth
                variant="outlined"
              />
              <TextField
                required
                margin="dense"
                id="stitching_fee"
                name="stitching_fee"
                label="Stitching fee/bag"
                onChange={handleInputChange}
                type="numeric"
                value={commoditiesData.stitching_fee}
                fullWidth
                variant="outlined"
              />
              <TextField
                required
                margin="dense"
                id="loading_fee"
                name="loading_fee"
                label="Loading fee/bag"
                onChange={handleInputChange}
                type="numeric"
                value={commoditiesData.loading_fee}
                fullWidth
                variant="outlined"
              />
              <TextField
                required
                margin="dense"
                id="tax_fee"
                name="tax_fee"
                label="Tax /bag"
                onChange={handleInputChange}
                type="numeric"
                step={0.01}
                value={commoditiesData.tax_fee}
                fullWidth
                variant="outlined"
              />
              <TextField
                required
                margin="dense"
                id="empty_sack_cost_fee"
                name="empty_sack_cost_fee"
                label="Empty sack cost"
                onChange={handleInputChange}
                type="numeric"
                value={commoditiesData.empty_sack_cost_fee}
                fullWidth
                variant="outlined"
              />
              <TextField
                required
                margin="dense"
                id="storage_fee"
                name="storage_fee"
                label="Storage fee/bag"
                onChange={handleInputChange}
                type="numeric"
                value={commoditiesData.storage_fee}
                fullWidth
                variant="outlined"
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose}>Cancel</Button>
              <Button onClick={createCommodities}>Update</Button>
            </DialogActions>
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={openn}
              onClick={handleCloss}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </Dialog>

          <Dialog open={bie} onClose={handleTum} fullWidth maxWidth="md">
            <DialogTitle>Register member to warehouse</DialogTitle>
            <form onSubmit={registerExistingMember}>
              <DialogContent>
                <p>All Members (excluding memebers already registered)</p>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={allMembers.Association_members}
                  getOptionLabel={(option) =>
                    `${option.firstname} ${option.lastname} (${option.association_name} => ${option.psb}) `
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.member_id === value.member_id
                  }
                  onChange={(event, value) =>
                    setExist({
                      ...exist,
                      member_id: value.member_id,
                      association_member_id: value.amid,
                    })
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="Select Member" size="small" />
                  )}
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleTum}>Cancel</Button>
                <Button variant="contained" color="success" type="submit">
                  Register
                </Button>
              </DialogActions>
            </form>
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={openn}
              onClick={handleCloss}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </Dialog>
          <Modal
            open={aggre_mode}
            onClose={() => setAggre_mode(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={aggre_style}>
              {all_aggregator ? (
                <List
                  sx={{
                    width: "100%",
                    maxWidth: 360,
                    bgcolor: "background.paper",
                  }}
                >
                  {all_aggregator.map((item) => (
                    <>
                      <ListItem
                        alignItems="flex-start"
                        secondaryAction={
                          <IconButton
                            onClick={() => handleNewAggre(item.user_id)}
                            edge="end"
                            aria-label="comments"
                          >
                            <CheckCircleIcon
                              color={
                                item.fullname === aggregator
                                  ? "success"
                                  : "primary"
                              }
                            />
                          </IconButton>
                        }
                      >
                        <ListItemAvatar>
                          <Avatar
                            alt="aggregator"
                            src={pic(item.picture_img)}
                          />
                        </ListItemAvatar>
                        <ListItemText
                          primary={item.fullname}
                          secondary={
                            <Box sx={{ display: "block" }}>
                              <div>
                                <Typography
                                  sx={{ display: "inline" }}
                                  component="span"
                                  variant="body2"
                                  color="text.primary"
                                >
                                  Contact: <b>{item.phone}</b>
                                </Typography>
                              </div>
                              <div>
                                <Typography
                                  sx={{ display: "inline" }}
                                  variant="body2"
                                  color="text.primary"
                                >
                                  Society: <b>{item.society}</b>
                                </Typography>
                              </div>
                            </Box>
                          }
                        />
                      </ListItem>
                      <Divider variant="inset" component="li" />
                    </>
                  ))}
                </List>
              ) : (
                <Box sx={{ display: "flex", textAlign: "center" }}>
                  <Typography>No Aggregators found</Typography>
                </Box>
              )}
            </Box>
          </Modal>

          <Modal
            open={modal_Open_no_all}
            onClose={closeam_all}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            {confirm_request_all ? (
              <Box sx={sec_style}>
                <>
                  <div
                    ref={printRef}
                    style={{ display: "block", marginBottom: 5 }}
                  >
                    <Typography
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      variant="body2"
                      sx={{ textAlign: "center", mb: 2 }}
                    >
                      ~The Cooperative~
                    </Typography>

                    <Typography
                      variant="h5"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      Commodity Storage
                    </Typography>
                    <Chip
                      sx={{ display: "flex", mt: 1, mb: 1 }}
                      label={confirm_request_all.Commodity}
                      variant="outlined"
                      color="success"
                    />
                    <Divider variant="middle" sx={{ mt: 1, mb: 1 }}>
                      <i>Member Details</i>
                    </Divider>

                    <div>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        variant="body2"
                      >
                        
                        <b style={{ color: "black" }}>
                          Date:{" "} 
                          <FormatedDate value={date} />
                        </b>
                      </Typography>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        variant="body2"
                      >
                        
                        <b style={{ color: "black" }}>Member:{" "} {member_fullname}</b>
                      </Typography>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        variant="body2"
                      >
                        
                        <b style={{ color: "black" }}>Passbook:{" "} {member_passbook_id}</b>
                      </Typography>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        variant="body2"
                      >
                        
                        <b style={{ color: "black" }}>Society:{" "} {society_name}</b>
                      </Typography>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        variant="body2"
                      >
                        <b style={{ color: "black" }}>
                        Kind:{" "}
                          {member_association_type}
                        </b>
                      </Typography>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        variant="body2"
                      >
                        <b style={{ color: "black" }}>
                        Savings Group:{" "}
                          {member_association_name}
                        </b>
                      </Typography>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        variant="body2"
                      >
                        Warehouse:{" "}
                        <b style={{ color: "black" }}>{warehouse_name}</b>
                      </Typography>
                    </div>

                    <Divider variant="middle" sx={{ mt: 2, mb: 2 }}>
                      <i>Commodity Specification</i>
                    </Divider>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ display: "block" }}>
                        <Typography
                          variant="h6"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          <b>Grade: {confirm_request_all.Grade}</b>{" "}
                        </Typography>
                        <Typography
                          variant="h6"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          
                          <b>
                            Current {confirm_request_all.Commodity} price:{" "}
                            {currencyFormat.format(
                              confirm_request_all.Current_commodity_price
                            )}
                          </b>{" "}
                        </Typography>
                        <Typography
                          variant="h6"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          
                          <b>Number of Bags:{" "} {confirm_request_all.Amount_storing} </b>{" "}
                        </Typography>
                        <Typography
                          variant="h6"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          <b>Units: {confirm_request_all.Unit_kg}kg</b>{" "}
                        </Typography>
                        <Typography
                          variant="h6"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          <b>Weight: {confirm_request_all.Weight}kg </b>{" "}
                        </Typography>
                        <Typography
                          variant="h6"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          <b>Tonnes: {confirm_request_all.Tons}</b>{" "}
                        </Typography>
                        <Typography
                          variant="h6"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          
                          <b>
                            Price per bag (Original):{" "}
                            {currencyFormat.format(
                              confirm_request_all.Price_per_bag
                            )}
                          </b>{" "}
                        </Typography>
                        <Typography
                          variant="h6"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          
                          <b>
                            Price per bag (Charged):{" "}
                            {currencyFormat.format(
                              confirm_request_all.charged_price_per_bg
                            )}
                          </b>{" "}
                        </Typography>
                        <Typography
                          variant="h6"
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          
                          <b>
                            Current cash value:{" "}
                            {currencyFormat.format(
                              confirm_request_all.total_cash_value
                            )}
                          </b>{" "}
                        </Typography>
                      </div>
                      <div
                        style={{
                          display: "block",
                          marginLeft: "3px",
                          borderColor: "blue",
                        }}
                      >
                        {charges[0] ? (
                          <>
                            <Typography
                              variant="subtitle"
                              fontStyle="oblique"
                              fontFamily="Futura"
                            >
                              <b>
                                <u>Charges associated</u>
                              </b>
                            </Typography>
                            <Typography
                              variant="h6"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            ><b>
                              Rebag (
                              {currencyFormat.format(charges[0].rebagging_fee)}
                              ):{" "}
                              
                                {fees.rebagging_fee === true
                                  ? "paid"
                                  : "no rebaging"}
                              </b>{" "}
                            </Typography>
                            <Typography
                              variant="h6"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            ><b>
                              Stack (
                              {currencyFormat.format(charges[0].stacking_fee)}):{" "}
                              
                                {fees.stacking_fee === true
                                  ? "paid"
                                  : "no stacking"}
                              </b>{" "}
                            </Typography>
                            <Typography
                              variant="h6"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            ><b>
                              Clean (
                              {currencyFormat.format(charges[0].cleaning_fee)}):{" "}
                              
                                {fees.cleaning_fee === true
                                  ? "paid"
                                  : "no cleaning"}
                              </b>{" "}
                            </Typography>
                            <Typography
                              variant="h6"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            ><b>
                              Destone (
                              {currencyFormat.format(charges[0].destoning_fee)}
                              ):{" "}
                              
                                {fees.destone === true
                                  ? "paid"
                                  : "no destoning"}
                              </b>{" "}
                            </Typography>
                            <Typography
                              variant="h6"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            ><b>
                              Store (
                              {currencyFormat.format(charges[0].storage_fee)}):{" "}
                              
                                {fees.storage_fee === true
                                  ? "paid"
                                  : "no storage_fee"}
                              </b>{" "}
                            </Typography>
                            <Typography
                              variant="h6"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            ><b>
                              Stitch (
                              {currencyFormat.format(charges[0].stitching_fee)}
                              ):{" "}
                              
                                {fees.stitching_fee === true
                                  ? "paid"
                                  : "no stitching"}
                              </b>{" "}
                            </Typography>
                            <Typography
                              variant="h6"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            ><b>
                              Load (
                              {currencyFormat.format(charges[0].loading_fee)}):{" "}
                              
                                {fees.loading_fee === true
                                  ? "paid"
                                  : "no loading"}
                              </b>{" "}
                            </Typography>
                            <Typography
                              variant="h6"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            ><b>
                              Empty Sack (
                              {currencyFormat.format(
                                charges[0].empty_sack_cost_fee
                              )}
                              ):{" "}
                              
                                {fees.empty_sack_cost_fee === true
                                  ? "paid"
                                  : "no empty sack"}
                              </b>{" "}
                            </Typography>
                            <Typography
                              variant="h6"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            ><b>
                              Tax ({currencyFormat.format(charges[0].tax_fee)}):{" "}
                              paid</b>{" "}
                            </Typography>
                          </>
                        ) : (
                          <Box sx={{ width: "100%", justifyContent: "center" }}>
                            <CircularProgress size="15" />
                          </Box>
                        )}
                      </div>
                    </div>
                  </div>
                  <Typography
                    sx={{ mt: 2 }}
                    variant="subtitle"
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    Print:
                  </Typography>
                  <IconButton onClick={handlePrint}>
                    <SummarizeIcon size="small" />
                  </IconButton>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginLeft: 320,
                    }}
                  >
                    <Button
                      variant="contained"
                      onClick={closeam_all}
                      color="error"
                      size="small"
                      sx={{ mr: 1 }}
                    >
                      Cancel
                    </Button>
                  </div>
                </>
              </Box>
            ) : (
              <Box sx={{ width: "100%", justifyContent: "center" }}>
                <CircularProgress size="15" />
              </Box>
            )}
          </Modal>

          {/* pay balance */}
          <Modal
            open={pay_modal}
            onClose={closePayModal}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
          >
            <Box sx={styler}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                    <b>
                      Farmer Name: {pay_data?.info?.firstname}{" "}
                      {pay_data?.info?.lastname ? pay_data?.info?.lastname : ""}
                    </b>
                  </Typography>
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                    <b>Passbook: {pay_data?.info?.passbook_id}</b>
                  </Typography>
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                    <b>
                      Balance to settle:{" "}
                      {currencyFormat.format(
                        pay_data?.act?.balance ? pay_data?.act?.balance : 0
                      )}
                    </b>
                  </Typography>
                </Grid>
                <Grid item xs={12} md={8}>
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={pay_data?.data}
                    fullWidth
                    getOptionLabel={(option) => option.account_name}
                    // getOptionDisabled={(option) =>
                    //   option.current_balance < society_data?.society_funds
                    // }
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    onChange={(event, value) => {
                      setSavin_id(value.id);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        helperText={
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Select Account to recieve payment</b>
                          </Typography>
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={8}>
                  <TextField
                    helperText={
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Amount</b>
                      </Typography>
                    }
                    size="small"
                    fullWidth
                    name="amount_re"
                    value={amount_re}
                    onChange={(e) => setAmount_re(e.target.value)}
                    type="number"
                    inputProps={{ step: "any" }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Chip
                    size="medium"
                    label={
                      <Tooltip title="select max to avoid incorrect decimals">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Max</b>
                        </Typography>
                      </Tooltip>
                    }
                    sx={{
                      borderRadius: 2,
                      m: 1,
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      backgroundColor: max === true ? "green" : "white",
                      color: max === true ? "#fff" : "#000",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "black",
                        color: "#fff",
                      },
                    }}
                    onClick={doMax}
                  />
                </Grid>
                <Grid item xs={12} md={8}>
                  <Chip
                    size="small"
                    label={
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Cancel</b>
                      </Typography>
                    }
                    sx={{
                      borderRadius: 2,
                      m: 1,
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "red",
                      color: "#fff",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "green",
                        color: "#fff",
                      },
                    }}
                    onClick={closePayModal}
                  />
                  {(amount_re <= pay_data?.act?.balance &&
                    amount_re <= house?.house_details?.current_balance) ||
                  max === true ? (
                    <Chip
                      size="small"
                      label={
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Confirm</b>
                        </Typography>
                      }
                      sx={{
                        borderRadius: 2,
                        m: 1,
                        boxShadow:
                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                        backgroundColor: "green",
                        color: "#fff",
                        "&:hover": {
                          boxShadow:
                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                          backgroundColor: "black",
                          color: "#fff",
                        },
                      }}
                      onClick={handleSettleFinally}
                    />
                  ) : (
                    <Typography
                      variant="subtitle"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>
                        Must not be greater than balance or warehouse current
                        balance
                      </b>
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </Box>
          </Modal>

          {/* release modal cash */}
          <Modal
            open={open_modal}
            onClose={handleCloseModal}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
          >
            <Box sx={styler}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={8}>
                  <DateTimePicker
                    name="date_rel"
                    value={rel_date}
                    onChange={(date) => setDate_rel(date)}
                    slotProps={{
                      textField: {
                        helperText: (
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>DateTime of transfer</b>
                          </Typography>
                        ),
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={8}>
                  <TextField
                    helperText={
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Amount</b>
                      </Typography>
                    }
                    size="small"
                    fullWidth
                    name="amount_rel"
                    value={amount_rel}
                    onChange={(e) => setAmount_rel(e.target.value)}
                    type="number"
                    inputProps={{ step: "any" }}
                  />
                </Grid>

                <Grid item xs={12} md={12}>
                  <TextField
                    helperText={
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Narration (Optional)</b>
                      </Typography>
                    }
                    size="small"
                    fullWidth
                    name="narration_rel"
                    value={narration_rel}
                    multiline
                    rows={4}
                    onChange={(e) => setNarration_rel(e.target.value)}
                  />
                </Grid>

                <Grid item xs={12} md={8}>
                  <Chip
                    size="small"
                    label={
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Cancel</b>
                      </Typography>
                    }
                    sx={{
                      borderRadius: 2,
                      m: 1,
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "red",
                      color: "#fff",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "green",
                        color: "#fff",
                      },
                    }}
                    onClick={handleCloseModal}
                  />
                  <Chip
                    size="small"
                    disabled={
                      !amount_rel ||
                      amount_rel > house?.house_details?.current_balance
                    }
                    label={
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Confirm</b>
                      </Typography>
                    }
                    sx={{
                      borderRadius: 2,
                      m: 1,
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "green",
                      color: "#fff",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "black",
                        color: "#fff",
                      },
                    }}
                    onClick={handleReleaseFinallyCash}
                  />
                </Grid>
              </Grid>
            </Box>
          </Modal>
          {/* release modal */}
          <Modal
            open={release_modal}
            onClose={closeReleaseModal}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
          >
            <Box sx={styler}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={8}>
                  <DateTimePicker
                    name="rel_date"
                    value={rel_date}
                    onChange={(date) => setRel_date(date)}
                    slotProps={{
                      textField: {
                        helperText: (
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>DateTime of transfer</b>
                          </Typography>
                        ),
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={8}>
                  <Chip
                    size="small"
                    label={
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Cancel</b>
                      </Typography>
                    }
                    sx={{
                      borderRadius: 2,
                      m: 1,
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "red",
                      color: "#fff",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "green",
                        color: "#fff",
                      },
                    }}
                    onClick={closeReleaseModal}
                  />
                  <Chip
                    size="small"
                    label={
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Confirm</b>
                      </Typography>
                    }
                    sx={{
                      borderRadius: 2,
                      m: 1,
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "green",
                      color: "#fff",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "black",
                        color: "#fff",
                      },
                    }}
                    onClick={handleReleaseFinally}
                  />
                </Grid>
              </Grid>
            </Box>
          </Modal>

          {/* retriva */}
          <Modal
            open={modal_Open_no_ret_all}
            onClose={handle_modal_Closee_ret_all}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            {confirm_request_all ? (
              <Box sx={sec_style}>
                <>
                  <div
                    ref={printRef_ret}
                    style={{ display: "block", marginBottom: 5 }}
                  >
                    <Typography
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      variant="body2"
                      sx={{ textAlign: "center", mb: 2 }}
                    >
                      ~The Cooperative~
                    </Typography>

                    <Typography
                      variant="h5"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      Commodity Retrieval
                    </Typography>
                    <Chip
                      sx={{ display: "flex", mt: 1, mb: 1 }}
                      label={confirm_request_all.Commodity}
                      variant="outlined"
                      color="success"
                    />
                    <Divider variant="middle" sx={{ mt: 1, mb: 1 }}>
                      <i>Member Details</i>
                    </Divider>

                    <div>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        variant="body2"
                      >
                        Date:{" "}
                        <b style={{ color: "black" }}>
                          {" "}
                          <FormatedDate value={date} />
                        </b>
                      </Typography>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        variant="body2"
                      >
                        Member:{" "}
                        <b style={{ color: "black" }}>{member_fullname}</b>
                      </Typography>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        variant="body2"
                      >
                        Passbook:{" "}
                        <b style={{ color: "black" }}>{member_passbook_id}</b>
                      </Typography>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        variant="body2"
                      >
                        Society:{" "}
                        <b style={{ color: "black" }}>{society_name}</b>
                      </Typography>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        variant="body2"
                      >
                        Kind:{" "}
                        <b style={{ color: "black" }}>
                          {member_association_type}
                        </b>
                      </Typography>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        variant="body2"
                      >
                        Savings Group:{" "}
                        <b style={{ color: "black" }}>
                          {member_association_name}
                        </b>
                      </Typography>
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        variant="body2"
                      >
                        Warehouse:{" "}
                        <b style={{ color: "black" }}>{warehouse_name}</b>
                      </Typography>
                    </div>

                    <Divider variant="middle" sx={{ mt: 2, mb: 2 }}>
                      <i>Commodity Specification</i>
                    </Divider>

                    <Typography
                      variant="h6"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      Grade: <b>{confirm_request_all.Grade}</b>{" "}
                    </Typography>
                    <Typography
                      variant="h6"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      Current {confirm_request_all.Commodity} price:{" "}
                      <b>
                        {currencyFormat.format(
                          confirm_request_all.Current_commodity_price
                        )}
                      </b>{" "}
                    </Typography>
                    <Typography
                      variant="h6"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      Bags retrieving:{" "}
                      <b>{confirm_request_all.Amount_storing} </b>{" "}
                    </Typography>
                    <Typography
                      variant="h6"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      Units: <b>{confirm_request_all.Unit_kg}kg</b>{" "}
                    </Typography>
                    <Typography
                      variant="h6"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      Weight: <b>{confirm_request_all.Weight}kg </b>{" "}
                    </Typography>
                    <Typography
                      variant="h6"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      Tonnes: <b>{confirm_request_all.Tons}</b>{" "}
                    </Typography>
                    <Typography
                      variant="h6"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      Price per bag (Charged):{" "}
                      <b>
                        {currencyFormat.format(
                          confirm_request_all.Price_per_bag
                        )}
                      </b>{" "}
                    </Typography>
                    <Typography
                      variant="h6"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      Value:{" "}
                      <b>
                        {currencyFormat.format(
                          confirm_request_all.total_cash_value
                        )}
                      </b>{" "}
                    </Typography>
                  </div>
                  <Typography
                    sx={{ mt: 2 }}
                    variant="subtitle"
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    Print:
                  </Typography>
                  <IconButton onClick={handlePrint_ret}>
                    <SummarizeIcon size="small" />
                  </IconButton>

                  <Button
                    variant="contained"
                    onClick={handle_modal_Closee_ret_all}
                    color="error"
                    size="small"
                    sx={{ mr: 1 }}
                  >
                    Cancel
                  </Button>
                </>
              </Box>
            ) : (
              <Box sx={{ width: "100%", justifyContent: "center" }}>
                <CircularProgress size="15" />
              </Box>
            )}
          </Modal>
        </Box>
      </main>
    </div>
  );
};
export default WareHouse;
